//diwakercode
'use client';
import { Box, Grid, GridItem, Img, Text } from '@chakra-ui/react';
import React, {useContext,useEffect,useState,useMemo,useCallback,useRef} from 'react';

import WeHaveChooseMinigame from '../FutureTheme/WeHaveChooseMinigame';
import MatchRankPreview from '../FutureTheme/Dragfornow';
import { ScenarioLearnerScore } from 'utils/gameApplication/gamePlayService';
import { AllLearnerscenarioLearderboard } from 'utils/game/gameService';
import { jsPDF } from 'jspdf';
import Interaction from './Interaction';
import InteractionFutureTheme from '../FutureTheme/InteractionFutureTheme';
import { motion } from 'framer-motion';
import { API_SERVER } from 'config/constant';
import { ScoreContext } from '../GamePreview';
import 'assets/css/CustomScroll.css';
import HologramGateQuest1 from '../../../../components/HologramOverview/HologramGateQuest1';
import HologramGateQuest2 from '../../../../components/HologramOverview/HologramGateQuest2';
import HologramGateQuest3 from "../../../../components/HologramOverview/HologramGateQuest3"
import HologramGateQuest4 from '../../../../components/HologramOverview/HologramGateQuest4';
import { storeRefqes1 } from 'utils/gameApplication/gamePlayService';
import Scrollbar from 'components/customScroll/CustomScroll';
import LoadImg from 'assets/gif/SpartanGif.gif';
import FuturePc from '../../../../assets/img/NewUI_Images/FuturePc.png';
import { storeRefqes } from 'utils/gameApplication/gamePlayService';
import LoadingScreen from '../FutureTheme/LoadingScreen';
import maleicon from '../../../../assets/Dialogueimgs/FutureMale.png';
import femaleicon from '../../../../assets/Dialogueimgs/Futurefemale.png';
import maleplayer2 from '../../../../assets/Dialogueimgs/MalePlayer2.png';
import maleplayer3 from '../../../../assets/Dialogueimgs/MalePlayer3.png';
import MaleMentor from '../../../../assets/Dialogueimgs/MaleMentor.png';
import FemaleMentor from '../../../../assets/Dialogueimgs/FemaleMentor.png';
import femaleplayer2 from '../../../../assets/Dialogueimgs/FemalePlayer2.png';
import femaleplayer3 from '../../../../assets/Dialogueimgs/FemalePlayer3.png';
import narratoricon from '../../../../assets/Dialogueimgs/NPC.png';
import ryanicon from '../../../../assets/Dialogueimgs/ryan.png';
import FemaleNPCIris from '../../../../assets/Dialogueimgs/FemaleNPCIris.png';
import MaleNPCRiven from '../../../../assets/Dialogueimgs/MaleNPCRiven.png';
import lenaicon from '../../../../assets/Dialogueimgs/lena.png';
import novaicon from '../../../../assets/Dialogueimgs/nova.png';
import MaleNPCAxel from '../../../../assets/Dialogueimgs/MaleNPCAxel.png';
import FemaleNPCNova from '../../../../assets/Dialogueimgs/FemaleNPCNova.png';
import axelicon from '../../../../assets/Dialogueimgs/Axel.png';
import animationSound from '../../../../assets/adiuo/Reflection sound2.mp3';
import zoomSound from '../../../../assets/adiuo/overview_sound1.mp3';
import flipSound from '../../../../assets/adiuo/keyinshits_sound.mp3';

import ScenarioCompletionFutureTheme from '../FutureTheme/ScenarioCompletionFutureTheme';
import ScenarioLeaderboard from '../FutureTheme/ScenarioLeaderboard.';

import { useColor } from '../../../../components/ui/ColorContext';

import { Buttons } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
// import imgBackground from "/images/background.png";
// import imgTopNav from 'assets/img/NewUI_Images/top-nav-bg.png';
import ColorPicker from '../../../../components/ui/ColorPicker';
import { Slider } from '../../../../components/ui/slider';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../../../../components/ui/dialog';
import { Card, CardContent } from 'Assessment/src/components/ui/card';
import { Button } from 'Assessment/src/components/ui/button';
import { ScenarioCard } from 'Assessment/src/components/ScenarioCard';
// import {card, CardContent} from 'Assessment/src/components/ui/card';
import { AudioRecorder } from 'Assessment/src/components/AudioRecorder';
import { RecordingInstructions } from 'Assessment/src/components/RecordingInstructions';
import { SuccessOverlay } from 'Assessment/src/components/SuccessOverlay';
import PreTraining from 'Assessment/src/pages/PreTraining';
import PostTraining from 'Assessment/src/pages/PostTraining';
// import { AudioRecorder } from 'Assessment/src/components/AudioRecorder';
import { TranscriptCard } from 'Assessment/src/components/TranscriptCard';
import { useNavigate } from 'react-router-dom';
import { useAssessmentSession } from 'Assessment/src/hooks/useAssessmentSession';
import { supabase } from 'Assessment/src/integrations/supabase/client';
import SwipeMiniGame from '../FutureTheme/SwipeMiniGame';
import StoryLoading from '../FutureTheme/StoryLoading';
import { createOrUpdateStoryBlock, updateInteractionBlock, updateReflectionBlock } from '../common';

const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

// Moved NavigationArrow outside to prevent recreation
const NavigationArrow: React.FC<{
  direction: 'left' | 'right';
  onClick: () => void;
  primaryColor: string;
}> = React.memo(({ direction, onClick, primaryColor }) => {
  const primaryColorRgb = hexToRgb(primaryColor);

  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-10 w-[3.75rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === 'left' ? '275.041deg' : '90deg'
        },
              rgba(${primaryColorRgb}, 0.6) 7.25%, rgba(${primaryColorRgb}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,
        boxShadow: `0px 0px 15.9542px 0px rgba(${primaryColorRgb}, 0.3)`,
      }}
    >
      {direction === 'left' ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
});

//diwakar code
const Feedback: React.FC<{
  content?: any; // string or string[] or HTML-like content
  onNavigate?: (direction: 'left' | 'right') => void;
}> = React.memo(({ content, onNavigate }) => {
  const { primaryColor } = useColor();
  const primaryColorRgb = useMemo(() => hexToRgb(primaryColor), [primaryColor]);

  // FeedbackContent: memoized parsing + rendering of content
  const FeedbackContent: React.FC<{ value: any }> = ({ value }) => {
    const normalized = useMemo(() => {
      if (value === null || value === undefined) return [];

      // If React element, return marker to render directly
      // @ts-ignore
      if (React.isValidElement && React.isValidElement(value)) return value;

      let contentVal: any = value;
      if (typeof contentVal === 'object' && !Array.isArray(contentVal)) {
        if ((contentVal as any).content)
          contentVal = (contentVal as any).content;
        else {
          try {
            contentVal = JSON.stringify(contentVal);
          } catch (e) {
            contentVal = String(contentVal);
          }
        }
      }

      const lines: string[] = Array.isArray(contentVal)
        ? contentVal
        : String(contentVal)
            .split(/\n|\r\n/)
            .map((l: string) => l.trim())
            .filter(Boolean);

      // Parse each line into { main, subs[] }
      return lines.map((raw: string) => {
        const cleaned = raw.replace(/^\s*[\u2022•\-]\s*/, '');
        const parts = cleaned
          .split(/<h1\s*\/?>/i)
          .map((p: string) => p.trim())
          .filter(Boolean);
        return { main: parts[0] || '', subs: parts.slice(1) };
      });
    }, [value]);

    // If normalized is a React element, render directly
    if (
      normalized &&
      !Array.isArray(normalized) &&
      (normalized as any).$$typeof
    ) {
      return <>{normalized as any}</>;
    }

    return (
      <>
        {Array.isArray(normalized) &&
          normalized.map((row: any, idx: number) => (
            <div key={idx} className="mb-4">
              <div className="font-medium leading-relaxed text-white">
                {row.main}
              </div>
              {row.subs && row.subs.length > 0 && (
                <div className="ml-8 mt-2 space-y-2 text-white">
                  {row.subs.map((s: string, si: number) => (
                    <div key={si} className="leading-relaxed">
                      {s}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
      </>
    );
  };

  return (
    <div
      className="relative h-full w-full overflow-hidden bg-cover bg-center bg-no-repeat"
      // style={{ backgroundImage: `url('${imgBackground}')` }}
    >
      <div className="relative flex h-full w-full   px-4 sm:px-6 lg:px-8">
        {/* Top Navigation Bar */}
        <div
          className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between px-4 sm:px-6 lg:px-8"
          style={{
            // backgroundImage: `url(${imgTopNav})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="flex items-center gap-6">
            {/* TopNavButton components would go here if needed */}
          </div>
          <div className="flex items-center gap-4">
            {/* StatusBar components would go here if needed */}
          </div>
        </div>

        {/* Feedback Content */}
        <div className="flex-grow-1 flex h-full flex-col items-start justify-center pt-24">
          <div
            className="relative flex h-full max-h-fit w-full max-w-xl flex-col items-center justify-start gap-5 overflow-hidden rounded-[2.375rem] px-6 pb-6 pt-5 backdrop-blur-[3.724rem] backdrop-filter"
            style={{
              animation: "slide-up 1000ms cubic-bezier(0.16, 1, 0.3, 1) both",
              background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${hexToRgb(
                primaryColor,
              )}, 0.2) 127.18%)`,
            }}
          >
            {/* Feedback Title */}
            <div className="relative">
              <h1
                className="text-center text-4xl font-normal tracking-[0.005rem]"
                style={{
                  color: primaryColor,
                  textShadow: `rgba(${hexToRgb(
                    primaryColor,
                  )}, 0.5) 0px 0px 10px`,
                }}
              >
                Feedback
              </h1>
            </div>

            {/* Decorative Line */}
            <div className="relative flex w-full items-center justify-center">
              <div className="w-full">
                <div className="relative h-[1px] w-full">
                  <svg
                    className="block h-[1px] w-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 537 1"
                  >
                    <line
                      stroke={`url(#paint0_linear_feedback_${primaryColor.replace(
                        '#',
                        '',
                      )})`}
                      strokeWidth="0.894962"
                      x2="537"
                      y1="0.552519"
                      y2="0.552519"
                    />
                    <defs>
                      <linearGradient
                        gradientUnits="userSpaceOnUse"
                        id={`paint0_linear_feedback_${primaryColor.replace(
                          '#',
                          '',
                        )}`}
                        x1="537"
                        x2="0"
                        y1="0.999899"
                        y2="0.99992"
                      >
                        <stop stopColor={primaryColor} stopOpacity="0" />
                        <stop
                          offset="0.484375"
                          stopColor={primaryColor}
                          stopOpacity="0.994792"
                        />
                        <stop
                          offset="1"
                          stopColor={primaryColor}
                          stopOpacity="0"
                        />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>

            {/* Feedback Content */}
            <div className="relative flex max-h-[500px] w-full flex-1 items-center justify-center overflow-y-auto px-1">
              <div className="mx-auto w-full max-w-3xl">
                <div className="font-rubik w-full text-[1.188rem] font-normal leading-[1.875rem] tracking-[-0.007rem] text-white">
                  <p className="block transition-all duration-300">
                    <FeedbackContent value={content} />
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom Navigation */}
            <div className="flex w-full items-center justify-between">
              <NavigationArrow
                direction="left"
                onClick={() => onNavigate?.('left')}
                primaryColor={primaryColor}
              />
              <NavigationArrow
                direction="right"
                onClick={() => onNavigate?.('right')}
                primaryColor={primaryColor}
              />
            </div>

            {/* Background Ellipse */}
            <div className="pointer-events-none absolute left-[11.067rem] top-[1.294rem] h-[30.04rem] w-[33.086rem] mix-blend-lighten">
              <div className="absolute bottom-[-102.084%] left-[-92.686%] right-[-92.686%] top-[-102.084%]">
                <svg
                  className="block h-full w-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 1512 1463"
                >
                  <g
                    filter={`url(#filter0_f_feedback_${primaryColor.replace(
                      '#',
                      '',
                    )})`}
                    id="Ellipse 7187"
                    opacity="0.2"
                    style={{ mixBlendMode: 'lighten' }}
                  >
                    <ellipse
                      cx="755.685"
                      cy="731.318"
                      fill={primaryColor}
                      rx="264.685"
                      ry="240.319"
                    />
                  </g>
                  <defs>
                    <filter
                      colorInterpolationFilters="sRGB"
                      filterUnits="userSpaceOnUse"
                      height="1461.94"
                      id={`filter0_f_feedback_${primaryColor.replace('#', '')}`}
                      width="1510.68"
                      x="0.34726"
                      y="0.34726"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        mode="normal"
                        result="shape"
                      />
                      <feGaussianBlur
                        result="effect1_foregroundBlur_53_81"
                        stdDeviation="245.326"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>

            {/* Inset Shadow Border */}
            <div
              className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
              style={{
                boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

const Dialogue: React.FC<{
  content?: string;
  characterName?: string; // NEW: dynamic character name
  characterAvatar?: string;
  onNavigate?: (direction: 'left' | 'right') => void;
  isFirstContent?: boolean; // NEW: hide left arrow when first content
}> = React.memo(
  ({
    content,
    characterName,
    characterAvatar,
    onNavigate,
    isFirstContent = false,
  }) => {
    const { primaryColor } = useColor();
    const primaryColorRgb = useMemo(
      () => hexToRgb(primaryColor),
      [primaryColor],
    );

    const dialogueText = content;

    const displayText = dialogueText;
    const isComplete = true;

    useEffect(() => {
      const handleKeyPress = (event: KeyboardEvent) => {
        if (
          !event.ctrlKey &&
          !event.altKey &&
          !event.metaKey &&
          !event.shiftKey
        ) {
          if (!isComplete) {
            // skipTypewriter();
          }
        }
      };

      window.addEventListener('keydown', handleKeyPress);
      return () => window.removeEventListener('keydown', handleKeyPress);
    }, [isComplete]);

    const handleSkipDialogue = useCallback(() => {
      if (!isComplete) {
        // skipTypewriter();
      }
    }, [isComplete]);

    const handleNavigation = useCallback(
      (direction: 'left' | 'right') => {
        onNavigate?.(direction);
      },
      [onNavigate],
    );

    return (
      <div className="relative h-screen w-full overflow-hidden bg-cover bg-center bg-no-repeat">
        <div className="flex h-full w-full flex-col justify-end px-4 sm:px-6 lg:px-10">
          {/* DIALOGUE BOX */}
          <div
            className="relative mx-auto  w-full rounded-2xl px-6 backdrop-blur-3xl"
            style={{
              background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
              boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,

              paddingTop: '0rem',
              paddingBottom: '2rem',
              marginBottom: '1rem',
            }}
          >
            <div className="flex gap-12">
              {/* LEFT — AVATAR + NAME */}
              <div className="relative flex flex-col items-center">
                {/* Dark Avatar Backplate */}
                <div
                  className=" rounded-full"
                  style={{
                    background:
                      'linear-gradient(21deg, rgb(10,10,10), rgb(50,50,50))',
                    zIndex: 1,
                    position: 'absolute',
                    top: '1.5rem',
                    left: '4.5rem',
                    width: '8rem',
                    height: '8rem',
                  }}
                />

                {/* Avatar Circle */}
                <div
                  className=" rounded-full p-3"
                  style={{
                    background: `rgba(${primaryColorRgb},0.12)`,
                    zIndex: 3,
                    position: 'absolute',
                    top: '1.75rem',
                    left: '4.75rem',
                  }}
                >
                  <div
                    className="relative  overflow-hidden rounded-full border"
                    style={{
                      borderColor: primaryColor,
                      width: '6rem',
                      height: '6rem',
                    }}
                  >
                    <img
                      src={characterAvatar}
                      alt={characterName}
                      className="h-full w-full rounded-full object-cover"
                    />
                  </div>

                  {/* Glowing Rim */}
                  <div
                    className="pointer-events-none absolute inset-0 rounded-full"
                    style={{
                      boxShadow: `
                  inset 0px 0px 12px rgba(${primaryColorRgb},0.3),
                  0px 0px 22px rgba(${primaryColorRgb},0.4)`,
                    }}
                  />
                </div>

                {/* CHARACTER NAME */}
                <h2
                  className="text-center text-3xl tracking-tight"
                  style={{
                    color: primaryColor,
                    textShadow: `0px 0px 12px rgba(${primaryColorRgb},0.7)`,
                    marginBottom: '-3rem',
                    marginLeft: '7rem',
                    marginTop: '10rem',
                  }}
                >
                  {characterName}
                </h2>
              </div>

              {/* RIGHT — DIALOGUE TEXT */}
              <div className="relative flex-1">
                {/* Light Glow Effects */}
                <div
                  className="absolute -top-32 right-10 h-80 w-80 rounded-full opacity-25 mix-blend-screen blur-[200px]"
                  style={{ background: primaryColor }}
                />

                <div
                  className="absolute -top-40 left-10 h-80 w-80 rounded-full opacity-15 mix-blend-screen blur-[200px]"
                  style={{ background: primaryColor }}
                />

                {/* TEXT BLOCK */}
                <p
                  className="font-rubik min-h-[6rem] cursor-pointer overflow-y-auto text-[1.194rem] 
                       leading-8 text-white hover:opacity-90"
                  onClick={handleSkipDialogue}
                  onDoubleClick={handleSkipDialogue}
                  style={{
                    marginTop: '1rem',
                    maxHeight: '8rem',
                    marginLeft: '2rem',
                    position: 'fixed',
                    left: '14rem',
                    marginRight: '2rem',
                    fontWeight: '400',
                  }}
                >
                  {displayText}
                </p>
              </div>
            </div>

            {/* NAVIGATION — LEFT & RIGHT ARROWS */}
            <div className="flex w-full items-center justify-between">
              <div>
                {!isFirstContent && (
                  <NavigationArrow
                    direction="left"
                    onClick={() => handleNavigation('left')}
                    primaryColor={primaryColor}
                  />
                )}
              </div>

              <NavigationArrow
                direction="right"
                onClick={() => handleNavigation('right')}
                primaryColor={primaryColor}
              />
            </div>

            {/* NEON BORDER GLOW */}
            <div
              className="pointer-events-none absolute inset-0 rounded-2xl"
              style={{
                boxShadow: `
            inset 0px 0px 12px rgba(${primaryColorRgb},0.3),
            0px 0px 22px rgba(${primaryColorRgb},0.2)`,
              }}
            />
          </div>
        </div>
      </div>
    );
  },
);
const npcIconMap: Record<number, string> = {
  33: ryanicon,
  27: lenaicon,
  25: novaicon,
  31: axelicon,
  153: FemaleNPCIris,
  156: MaleNPCRiven,
  154: FemaleNPCNova,
  155: MaleNPCAxel,
};
const Story: React.FC<{
 
  gameProgressData?:any;
  setGameProgressData?:any;
  onScenarioCompleted?: (scenarioName: string, questNo: number) => void;
   fetchblockScore?: (score:any) => void;
  BlockSeqNextPreviousNotes: (inputId?:any,questno?:any) => void;
   setOptions?:any;
   seconds?:any;
   setData:any;
  currentReplayInfo: any;
  setLastInteractionScore: any;
  setShowScenarioLeaderboard: any;
  showScenarioLeaderboard: any;
    toggleAudioPlayPause?:any;
  setShowScenarioTransition:any;
  showScenarioTransition:any;
  setBadgethpath?: any;
  badgethpath?: any;
  setBadgename?: any;
  badgename?: any;
  setActivitydata: any;
  Activitydata: any;
  setSceneriowiseEarnedScore: any;
   setscenariowisebestscore1:any;
    scenariowisebestscore1:any;
  setSceneriowiseHighestEarnedScore: any;
  setScenarioTotalScore: any;
  setScenarioAllTimeScore: any;
  sceneriowiseEarnedScore: any;
  sceneriowiseHighestEarnedScore: any;
  scenarioTotalScore: any;
  scenarioAllTimeScore: any;
  setisScreenshot?: any;
  isScreenshot?: any;
  getFeedbackData?: any;

  FeedbackcurrentPosition?: any;
  profile?: any;

  setFeedbackCurrentPosition?: any;
  currentScreenId?: number;
  backgroundScreenUrl?: string;
  // InitialScreenId: number;
  data?: any;

  handleScenarioReplayButtonClick?: any;
  loadingProgress?: any;
  type?: any;
  setType?: any;
  interactionfeedback?: any;
  profileData: any;
  getData: any;
  options: any;
  getSelectedOptions: any;
  handleValidate: any;
  resMsg: any;
  feed: any;
  formData: any;
  setAudioObj: any;
  selectedPlayer: any;
  setNavTrack: any;
  navTrack: any;
  gameInfo: any;
  preloadedAssets: any;
  LastModiPrevData: any;
  RepeatSelectOption: any;
  RepeatPrevOption: any;
  setScore: any;
  SetAudioOptions: any;
  score: any;
  AudioOptions: any;
  upComingBlockChoosen?: any;
  modalLoaded: any;
  learnerPlayList: any;
  option: any;
  SetGlbPlayingDetails: any;
  isZoomComplete: any;
  setIsZoomComplete: any;
  NonPlayerNameLanguage: any;
  setNonPlayerNameLanguage: any;
  questState: any;
  originalScore: any;
  setLearnerPlayingDetails: any;
  navi: any;
  currentBlock: any;
  setIsInteractionButtonDisabled: any;
  isInteractionButtonDisabled: any;
  handleInteractionBackClick: any;

  homeLeaderBoard: any;
  setHomeLeaderBoard: any;
  setCurrentScreenId: any;
  setPlayerTodayScore: any;
  playerTodayScore: any;
  setCurrentQuestNo: any;
  setFirstLoading: any;
  learner_game_play_id: any;

  scenarioMinScore: any;
  setScenarioMinScore: any;
  scenarioDistinctionScore: any;
  setScenarioDistinctionScore: any;
  setNonPlayerNameLanguageId: any;
  scenarioNpc: any;
  NonPlayerNameLanguageId: any;
  filteredCharacterGLBs: any;
  setWalkanimation: any;
  setNextcharacter: any;
  walkanimation: any;
  nextcharacter: any;
   isAudioPaused?: boolean;
  progress?: any;
  onNavigate?: any;
  currentQuestNo?: number;
   audioCache?: any;
  audioReady?: boolean;
  setNextcharactervoice:any;
  nextcharactervoice:any;
     WeHaveChooseCompleted?: any;
setWeHaveChooseCompleted?: any;

isSwipeMiniGameCompleted?: any;
setIsSwipeMiniGameCompleted?: any;

isDragForNowCompleted?: any;
setIsDragForNowCompleted?: any;
  isDoorEntry?: boolean;
  setIsDoorEntry?: (value: boolean) => void;
  setOptionalReplayTracked:any;
  AssignId:any
}> = React.memo(
  ({
 
     AssignId,
    setGameProgressData,
    gameProgressData,
    setOptions,
    setData,
    seconds,
    BlockSeqNextPreviousNotes,
    fetchblockScore,
    setLastInteractionScore,
     setscenariowisebestscore1,
    scenariowisebestscore1,
    onScenarioCompleted,
    currentReplayInfo,
    setShowScenarioLeaderboard,
    showScenarioLeaderboard,
     isDoorEntry,
    setIsDoorEntry,
      toggleAudioPlayPause,
          WeHaveChooseCompleted,
  setWeHaveChooseCompleted,
  isSwipeMiniGameCompleted,
  setIsSwipeMiniGameCompleted,
  isDragForNowCompleted,
  setIsDragForNowCompleted,

    setShowScenarioTransition,
    showScenarioTransition,
    nextcharactervoice,
    setNextcharactervoice,
    setBadgethpath,
    setBadgename,
    badgename,
    badgethpath,
    setActivitydata,
    Activitydata,
    setSceneriowiseEarnedScore,
    sceneriowiseHighestEarnedScore,
    setSceneriowiseHighestEarnedScore,
    setScenarioTotalScore,
    setScenarioAllTimeScore,
    sceneriowiseEarnedScore,
    scenarioTotalScore,
    scenarioAllTimeScore,

    scenarioMinScore,
    setScenarioMinScore,
    scenarioDistinctionScore,
    setScenarioDistinctionScore,

    setisScreenshot,
    isScreenshot,
    currentScreenId,
    getFeedbackData,
    backgroundScreenUrl,
    FeedbackcurrentPosition,

    setFeedbackCurrentPosition,
    // InitialScreenId,
    learner_game_play_id,
    handleScenarioReplayButtonClick,
    loadingProgress,
 progress,
    onNavigate,
    setIsInteractionButtonDisabled,
    isInteractionButtonDisabled,
    handleInteractionBackClick,
    data,
    type,
    setType,
    interactionfeedback,
    resMsg,
    feed,
    getSelectedOptions,
    getData,
    profileData,
    options,
    setAudioObj,
    handleValidate,
    formData,
    selectedPlayer,
    setNavTrack,
    navTrack,
    gameInfo,
    preloadedAssets,
    LastModiPrevData,
    RepeatSelectOption,
    RepeatPrevOption,
    setScore,
    SetAudioOptions,
    score,
    AudioOptions,
    upComingBlockChoosen,
    modalLoaded,
    learnerPlayList,
    option,
    SetGlbPlayingDetails,
    setIsZoomComplete,
    isZoomComplete,
    setNonPlayerNameLanguage,
    NonPlayerNameLanguage,
    questState,
    originalScore,
    setLearnerPlayingDetails,
    navi,
    currentBlock,
    homeLeaderBoard,
    setHomeLeaderBoard,
    setCurrentScreenId,
    setPlayerTodayScore,
    playerTodayScore,
    setCurrentQuestNo,
    currentQuestNo,
    setFirstLoading,
    scenarioNpc,
    setNonPlayerNameLanguageId,
    NonPlayerNameLanguageId,
    filteredCharacterGLBs,
    setNextcharacter,
    setWalkanimation,
    walkanimation,
    nextcharacter,
    isAudioPaused,
     audioCache,
    audioReady,
    setOptionalReplayTracked
  }) => {
    const currentVoiceRef = useRef<HTMLAudioElement | null>(null);
    const { session } = useAssessmentSession(formData, learnerPlayList);
    const [scoreLoaded, setScoreLoaded] = useState(false);
    const questNo = data?.blockQuestNo;

    // → 1
    const blockNo = data?.blockSecondaryId;
    // → 1

    const isScenarioLeaderboardEnabled =
      gameInfo?.blocks?.[questNo]?.[blockNo]?.scLeaderboardEnabled === 'true';

    // ## ScenarioCompletion ↔ Leaderboard toggle
    // const [showScenarioLeaderboard, setShowScenarioLeaderboard] =
    //   useState(false);
    const [isNavigatingNext, setIsNavigatingNext] = useState(false);
   
const [scoresInScenarioLeaderboard, setScoresInScenarioLeaderboard] = useState([]);

    const { primaryColor } = useColor();
    const primaryColorRgb = useMemo(
      () => hexToRgb(primaryColor),
      [primaryColor],
    );

    // Assessment session hook - must be called at top level
    // const { session } = useAssessmentSession(formData, learnerPlayList);

    useEffect(() => {}, [currentBlock]);

    const [currentBlockTest, setCurrentBlockTest] = useState(currentBlock);
    useEffect(() => {
      setCurrentBlockTest(currentBlock);
    }, [currentBlock]);

    const [preAssessmentCompleted, setPreAssessmentCompleted] = useState(false);
    const [preAssessmentShowingMessage, setPreAssessmentShowingMessage] = useState(false);
   // const prevTypeRef = useRef<string | null>(null);
 // Clean up old sessionStorage keys from previous logic versions
    useEffect(() => {
      Object.keys(sessionStorage)
        .filter(k => k.startsWith('preAssessmentVisited_') || k === 'preAssessmentCompleted_quest_undefined' || k === 'preAssessmentCompleted_quest_default')
        .forEach(k => sessionStorage.removeItem(k));
    }, []);

    // Listen for PreAssessment completion
   useEffect(() => {
      const handlePreAssessmentComplete = () => {
        setPreAssessmentCompleted(true);
        // Mark this specific quest's PreAssessment as completed
      };

      window.addEventListener(
        'preAssessmentComplete',
        handlePreAssessmentComplete,
      );
      return () =>
        window.removeEventListener(
          'preAssessmentComplete',
          handlePreAssessmentComplete,
        );
    }, []);

    // When navigating to PreAssessment, check if we're returning (from another type) or first entering
    useEffect(() => {
      if (type !== 'PreAssessment') return;

      const questKey = String(currentQuestNo ?? profile?.currentQuest ?? 'default');
      const completedKey = `preAssessmentCompleted_quest_${questKey}`;
      const wasCompleted = sessionStorage.getItem(completedKey) === 'true';

      setPreAssessmentShowingMessage(wasCompleted);
    }, [type, currentQuestNo]);

    // PostAssessment completion state
    const [postAssessmentCompleted, setPostAssessmentCompleted] =
      useState(() => !!localStorage.getItem("postAssestment"));

    // PreAssessment state (similar to PreTraining)
    const [
      preAssessmentSubmitButtonVisible,
      setPreAssessmentSubmitButtonVisible,
    ] = useState(false);
    // const [preAssessmentCompleted, setPreAssessmentCompleted] = useState(false);

    // PostAssessment state for checking completion
    const [hasPostAssessmentResults, setHasPostAssessmentResults] = useState<
      boolean | null
    >(null);

    // Check PostAssessment completion status

    // ## BACK FROM SCENARIO LEADERBOARD
    const onLeaderboardBack = () => {
      // ## hide leaderboard
      setShowScenarioLeaderboard(false);
    };
  const { profile, setProfile ,setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
    const [showTypingEffect, setShowTypingEffect] = useState<any>(false);
    const [interactionNext, setInteractionNext] = useState(null);
    const [contentByLanguage, setContentByLanguage] = useState(null);
    const [showResults, setShowResults] = useState(false);
    const EnumType = {
      BGM: 'bgm',
      VOICE: 'voice',
    };
    const [animateNote, setAnimateNote] = useState<boolean>(false);
    const [animateDialog, setAnimateDialog] = useState<boolean>(false);
    const [animateInteraction, setAnimateInteraction] =
      useState<boolean>(false);
    const [animateFeedback, setAnimateFeedback] = useState<boolean>(false);
    const [basedOnNDI, setBasedOnNDI] = useState<any>('');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isBackDisabled, setIsBackDisabled] = useState(false);
    const audioFiles = {
      IntroMusic: require('../../../../assets/adiuo/intromusicone.mp3'),
    };
    //   const questNo = data?.blockQuestNo;        // → 1
    // const blockNo = data?.blockSecondaryId;    // → 1

    //const isScenarioLeaderboardEnabled =
    //gameInfo?.blocks?.[questNo]?.[blockNo]?.blockscenariocmleaderboard === "true";

    useEffect(() => {
      const checkPostAssessmentResults = async () => {
        if (!session || type !== 'PostAssessment') return;

        try {
          const { data: assessment, error } = await supabase
            .from('assessments')
            .select('evaluation_json, post_transcript')
            .eq('id', session.assessmentId)
            .single();

          if (!error && assessment) {
            const hasResults = !!(
              assessment.evaluation_json && assessment.post_transcript
            );

            // Check if this is a replay scenario or first-time playing
            const currentQuest = parseInt(profile?.currentQuest || '1');
            const isReplay =
              formData?.isReplay ||
              learnerPlayList?.isReplay ||
              formData?.gameType === 'replay' ||
              learnerPlayList?.gameType === 'replay' ||
              questState[currentQuest] === 'replayallowed';
            const isFirstTime = !session.hasCompletedBefore;

            // For replay scenarios: always show full assessment flow
            // For first-time playing: show full assessment flow
            // For go back scenarios (completed users who are not replaying): show only results
            setHasPostAssessmentResults(
              hasResults && !isReplay && !isFirstTime,
            );
          } else {
            setHasPostAssessmentResults(false);
          }
        } catch (error) {
          console.error('Error checking PostAssessment results:', error);
          setHasPostAssessmentResults(false);
        }
      };

      checkPostAssessmentResults();
    }, [
      session,
      type,
      questState,
      profile?.currentQuest,
      formData,
      learnerPlayList,
    ]);

    const [scenarioCompletionDone, setScenarioCompletionDone] = useState(false);

    const onScenarioCompletionNext = () => {
      if (
        // gameInfo?.blocks?.[questNo]?.[blockNo]?.scLeaderboardEnabled === "true"
        // && !showScenarioLeaderboard
        data.scLeaderboardEnabled === 'true'
      ) {
        // ## FIRST TIME ONLY → SHOW LEADERBOARD
        setShowScenarioLeaderboard(true);
        return true; // ## tell ScenarioCompletion to STOP old flow
      }

      return false; // ## allow old flow
    };

    
    useEffect(() => {
      if (!scenarioCompletionDone) return;

      if (data?.scLeaderboardEnabled === 'true') {
        // AllLearnerLearderboard();
      } else {
        // upNext(); // or upNext()
      }
    }, [scenarioCompletionDone]);
    const musicRef = React.useRef(null);

    useEffect(() => {
      if (isLoading && !isDoorEntry) {
        // 🎵 Play Bill’s music when loader starts
        musicRef.current = new Audio(audioFiles.IntroMusic);
        musicRef.current.loop = true; // optional looping
        musicRef.current.volume = 0.8; // optional volume control (0–1)
        musicRef.current.play().catch((err: any) => {
          console.warn('Autoplay blocked by browser:', err);
        });
      } else {
        // ⏹️ Stop music when loader ends
        if (musicRef.current) {
          musicRef.current.pause();
          musicRef.current.currentTime = 0;
        }
      }

      // 🧹 Cleanup on unmount
      return () => {
        if (musicRef.current) {
          musicRef.current.pause();
          musicRef.current.currentTime = 0;
        }
      };
    }, [isLoading,isDoorEntry]);
  const stopAllAudio = () => {
  // Stop all <audio> elements
  document.querySelectorAll('audio').forEach((audio) => {
    audio.pause();
    audio.currentTime = 0;
    audio.muted = true;
  });

  // Suspend existing AudioContext (if any)
  if ((window as any)._gameAudioCtx) {
    try {
      (window as any)._gameAudioCtx.suspend();
    } catch (e) {}
  }
};

// useEffect(() => {
//   if (showScenarioTransition) {
//     stopAllAudio();
//   }
// }, [showScenarioTransition]);

useEffect(() => {
  if (showScenarioTransition) {
    stopAllAudio();
  }else{// 🔥 UNMUTE ALL AUDIO WHEN BACK
    document.querySelectorAll('audio').forEach((audio: any) => {
      audio.muted = false;
      audio.currentTime = 0;   // 🔥 reset to start
      audio.play().catch(() => {}); // 🔥 play again (handle autoplay block)
    });
  }
}, [showScenarioTransition]);

    // useEffect(() => {
    //   if (modalLoaded) {
    //     setTimeout(() => {
    //       setIsLoading(false);
    //         setIsDoorEntry?.(false);
    //     }, 6000);
    //   } else {
    //     setIsLoading(true);
    //   }
    // }, [modalLoaded]);

     useEffect(() => {
      if (modalLoaded) {
        setTimeout(() => {
          setIsLoading(false);
          setIsDoorEntry?.(false);
        }, 6000);
      } else {
        setIsLoading(true);
        setIsDoorEntry(true);
      }
    }, [modalLoaded]);

    const getKeyInsightsLines = (blockText: any): string[] => {
      if (!blockText) return [];

      // If already an array
      if (Array.isArray(blockText)) {
        return blockText;
      }

      // If string → split by line breaks
      if (typeof blockText === 'string') {
        return blockText
          .split(/\n+/)
          .map((line) => line.trim())
          .filter(Boolean);
      }

      return [];
    };

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const learnerId = user?.data?.id;

    const fetchLearnerScore = async () => {
      try {
        const result = await ScenarioLearnerScore({
          gameId: data?.blockGameId,
          scenario: data?.blockScenario,
          learnerId: learnerId,
          questNo: data?.blockQuestNo,
           activityId: Activitydata
        });

        if (result?.success) {
            setscenariowisebestscore1(result.scenariowisebestscore);
          setSceneriowiseEarnedScore(result.totalScore);
          setSceneriowiseHighestEarnedScore(result.totalScore1);
          setScenarioTotalScore(result.scenarioTotalScore);
          setScenarioAllTimeScore(result.allTimeScore);
          setScenarioMinScore(result.minimumScore);
          setScenarioDistinctionScore(result.distinctionScore);
          setBadgethpath(result.badgeImage);
          setBadgename(result.badgeName);
           setScoreLoaded(true);
        }
      } catch (err) {
        console.error('Failed to fetch backend score', err);
      }
    };

    useEffect(() => {
      if (type === 'ScenarioCompletion') {
        fetchLearnerScore();
         setScoreLoaded(false);
      }
    }, [type]);

    const questNames: Record<number, string> = {
      1: 'Goal Setting',
      2: 'Delegation',
      3: 'Giving Feedback',
      4: 'Conflict Management',
    };

    const handleDownloadPDF = async () => {
      const rawText =
        contentByLanguage !== null ? contentByLanguage : data?.blockText || '';

      if (!rawText) return;

      // Local helper: resolve image URL/data to {dataUrl, mime} for PDF embedding
      const resolveImageToDataUrl = async (rawUrl: string) => {
        try {
          if (!rawUrl) return null;
          if (/^data:/i.test(rawUrl)) {
            const mimeMatch = rawUrl.match(/^data:([^;]+);base64,/i);
            return {
              dataUrl: rawUrl,
              mime: mimeMatch ? mimeMatch[1] : 'image/png',
            };
          }

          let url = rawUrl;

          // Extract actual image URL from Next.js image optimization endpoint
          if (url.includes('/_next/image')) {
            const urlParam = new URL(url).searchParams.get('url');
            if (urlParam) {
              url = decodeURIComponent(urlParam);
            }
          }

          if (url.startsWith('/')) url = window.location.origin + url;
          if (!/^https?:\/\//i.test(url))
            url = new URL(url, window.location.href).toString();

          // Try XMLHttpRequest blob approach (better CORS handling)
          try {
            const xhr = await new Promise<Blob | null>((resolve) => {
              const request = new XMLHttpRequest();
              request.open('GET', url, true);
              request.responseType = 'blob';
              request.onload = () => {
                if (
                  request.status === 200 &&
                  request.response.type.startsWith('image/')
                ) {
                  resolve(request.response);
                } else {
                  resolve(null);
                }
              };
              request.onerror = () => {
                resolve(null);
              };
              request.timeout = 10000;
              request.ontimeout = () => {
                resolve(null);
              };
              request.send();
            });

            if (xhr) {
              const dataUrl = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result as string);
                reader.onerror = reject;
                reader.readAsDataURL(xhr);
              });
              const mimeMatch = (dataUrl || '').match(/^data:([^;]+);base64,/);
              const mime = mimeMatch ? mimeMatch[1] : xhr.type || 'image/jpeg';

              return { dataUrl, mime };
            }
          } catch (e) {
            console.error('XHR approach failed:', e);
          }

          // Try fetch with include credentials
          try {
            const res = await fetch(url, {
              mode: 'cors',
              credentials: 'include',
            });

            if (res && res.ok) {
              const blob = await res.blob();
              if (blob.type.startsWith('image/')) {
                const dataUrl = await new Promise<string>((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                });
                const mimeMatch = (dataUrl || '').match(
                  /^data:([^;]+);base64,/,
                );
                const mime = mimeMatch
                  ? mimeMatch[1]
                  : blob.type || 'image/jpeg';

                return { dataUrl, mime };
              }
            }
          } catch (e) {
            console.error('Fetch approach failed:', e);
          }

          // Canvas rendering (with multiple approaches)
          const imageUrl = url;

          // First attempt: with crossOrigin
          const canvasResult1 = await new Promise<{
            dataUrl: string;
            mime: string;
          } | null>((resolve) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            let resolved = false;

            const timeout = setTimeout(() => {
              if (!resolved) {
                resolved = true;
                resolve(null);
              }
            }, 10000);

            img.onload = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                try {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.naturalWidth || img.width || 800;
                  canvas.height = img.naturalHeight || img.height || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(img, 0, 0);
                    const dataUrl = canvas.toDataURL('image/png');

                    resolve({ dataUrl, mime: 'image/png' });
                    return;
                  }
                } catch (err) {
                  console.error('Canvas with CORS error:', err);
                }
                resolve(null);
              }
            };
            img.onerror = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                resolve(null);
              }
            };
            img.src = imageUrl;
          });

          if (canvasResult1) return canvasResult1;

          // Second attempt: without crossOrigin
          const canvasResult2 = await new Promise<{
            dataUrl: string;
            mime: string;
          } | null>((resolve) => {
            const img = new Image();
            let resolved = false;

            const timeout = setTimeout(() => {
              if (!resolved) {
                resolved = true;
                resolve(null);
              }
            }, 10000);

            img.onload = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                try {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.naturalWidth || img.width || 800;
                  canvas.height = img.naturalHeight || img.height || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(img, 0, 0);
                    const dataUrl = canvas.toDataURL('image/png');

                    resolve({ dataUrl, mime: 'image/png' });
                    return;
                  }
                } catch (err) {
                  console.error('Canvas without CORS error:', err);
                }
                resolve(null);
              }
            };
            img.onerror = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                resolve(null);
              }
            };
            img.src = imageUrl;
          });

          return canvasResult2;
        } catch (err) {
          console.warn('resolveImageToDataUrl failed:', err);
          return null;
        }
      };

      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginLeft = 15;
      let y = 25;

      // 🎯 Title
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      //kaviya
      const currentQuestNumber = parseInt(profile?.currentQuest) || 1;
      const questName = questNames[currentQuestNumber] || 'Quest';
      // const title = `${gameInfo.gameData.gameTitle} Keyinsights`;
      const title = `Project Echo ${questName} Key Insights`;

      const titleWidth = doc.getTextWidth(title);
      const centerX = (pageWidth - titleWidth) / 2;
      doc.text(title, centerX, y);
      y += 12;

      // Split content by images, videos and URLs while preserving them (SAME LOGIC AS WEB PAGE)
      const parts = rawText.split(
        /(<img[^>]*>|<video[^>]*>.*?<\/video>|https?:\/\/[^\s]+)/gi,
      );

      // Process each part in order (SAME LOGIC AS WEB PAGE)
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        // Skip empty parts
        if (!part || !part.trim()) continue;

        // Check if part is an image tag
        const imgMatch = part.match(/<img[^>]*src=["']([^"']+)["'][^>]*>/i);
        // Check if part is a plain URL
        const urlMatch = part.match(/^https?:\/\/[^\s]+$/i);

        if (imgMatch && imgMatch[1]) {
          // Process image from img tag (SAME LOGIC AS WEB PAGE)
          try {
            const imageUrl = imgMatch[1];
            const resolved = await resolveImageToDataUrl(imageUrl);
            if (resolved && resolved.dataUrl) {
              let { dataUrl, mime } = resolved;
              let format: 'PNG' | 'JPEG' =
                mime && mime.includes('png') ? 'PNG' : 'JPEG';

              if (mime === 'image/svg+xml' && dataUrl) {
                try {
                  const svgImg = new Image();
                  const svgLoaded: Promise<void> = new Promise((resolv) => {
                    svgImg.onload = () => resolv();
                    svgImg.onerror = () => resolv();
                  });
                  svgImg.src = dataUrl;
                  await svgLoaded;
                  const canvas = document.createElement('canvas');
                  canvas.width = svgImg.naturalWidth || 800;
                  canvas.height = svgImg.naturalHeight || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(svgImg, 0, 0, canvas.width, canvas.height);
                    dataUrl = canvas.toDataURL('image/png');
                    format = 'PNG';
                  }
                } catch (err) {}
              }

              const imgEl = new Image();
              const imgLoaded: Promise<void> = new Promise((resolv) => {
                imgEl.onload = () => resolv();
                imgEl.onerror = () => resolv();
              });
              imgEl.src = dataUrl as string;
              await imgLoaded;

              const maxWidth = pageWidth - marginLeft * 2;
              const displayW = maxWidth;
              const displayH =
                imgEl.naturalHeight && imgEl.naturalWidth
                  ? (imgEl.naturalHeight / imgEl.naturalWidth) * displayW
                  : displayW * 0.6;

              if (y + displayH > doc.internal.pageSize.getHeight() - 25) {
                doc.addPage();
                y = 25;
              }

              try {
                doc.addImage(
                  dataUrl as string,
                  format,
                  marginLeft,
                  y,
                  displayW,
                  displayH,
                );
                y += displayH + 8;
              } catch (err) {
                console.warn('addImage failed', err);
              }
            }
          } catch (e) {
            console.warn('Image embed failed', e);
          }
        } else if (urlMatch && urlMatch[0]) {
          // Process plain URL - check type first (video, image, or website)
          try {
            const url = urlMatch[0];

            // Check if URL is a video URL (strict detection - only if clearly a video)
            const isVideoUrl =
              /\.(mp4|webm|ogg|mov|avi)(\?|$)/i.test(url) ||
              /\/(video|watch|embed)/i.test(url) ||
              /youtube|youtu\.be|vimeo|dailymotion/i.test(url);

            if (isVideoUrl) {
              // Video URL - display as text link only
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 255); // Blue color for links

              if (y > doc.internal.pageSize.getHeight() - 10) {
                doc.addPage();
                y = 25;
              }

              const shortUrl =
                url.length > 80 ? url.substring(0, 77) + '...' : url;
              doc.text('Video: ' + shortUrl, marginLeft, y, {
                maxWidth: pageWidth - marginLeft * 2,
              });
              doc.setTextColor(0, 0, 0); // Reset to black
              y += 8;
            } else {
              // For all other URLs: Try to download as image first, fallback to website link
              let resolved = null;

              // Try to resolve as image (with retry - 3 attempts with delay)
              for (let attempt = 0; attempt < 3; attempt++) {
                resolved = await resolveImageToDataUrl(url);
                if (resolved && resolved.dataUrl) {
                  break; // Successfully resolved
                }
                // Wait before retry
                if (attempt < 2) {
                  await new Promise((r) => setTimeout(r, 500)); // Increased delay to 500ms
                }
              }

              if (resolved && resolved.dataUrl) {
                // Successfully downloaded as image - embed it
                let { dataUrl, mime } = resolved;
                let format: 'PNG' | 'JPEG' =
                  mime && mime.includes('png') ? 'PNG' : 'JPEG';

                const imgEl = new Image();
                const imgLoaded: Promise<void> = new Promise((resolv) => {
                  imgEl.onload = () => resolv();
                  imgEl.onerror = () => resolv();
                });
                imgEl.src = dataUrl as string;
                await imgLoaded;

                const maxWidth = pageWidth - marginLeft * 2;
                const displayW = maxWidth;
                const displayH =
                  imgEl.naturalHeight && imgEl.naturalWidth
                    ? (imgEl.naturalHeight / imgEl.naturalWidth) * displayW
                    : displayW * 0.6;

                if (y + displayH > doc.internal.pageSize.getHeight() - 25) {
                  doc.addPage();
                  y = 25;
                }

                try {
                  doc.addImage(
                    dataUrl as string,
                    format,
                    marginLeft,
                    y,
                    displayW,
                    displayH,
                  );
                  y += displayH + 8;
                } catch (err) {
                  console.warn('addImage failed', err);
                }
              } else {
                // Image download failed - display URL as link
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(9);
                doc.setTextColor(0, 0, 255); // Blue color for links

                if (y > doc.internal.pageSize.getHeight() - 10) {
                  doc.addPage();
                  y = 25;
                }

                const shortUrl =
                  url.length > 80 ? url.substring(0, 77) + '...' : url;
                doc.text('Link: ' + shortUrl, marginLeft, y, {
                  maxWidth: pageWidth - marginLeft * 2,
                });
                doc.setTextColor(0, 0, 0); // Reset to black
                y += 8;
              }
            }
          } catch (e) {
            console.warn('URL processing failed', e);
          }
        } else {
          // Process text content - filter out parts that are too short or just whitespace
          const trimmedPart = part.trim();

          // Skip parts that are just single characters or very short fragments (less than 3 characters)
          if (trimmedPart.length < 3) continue;

          const lines = getKeyInsightsLines(trimmedPart);

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0); // Ensure text is black

          lines.forEach((line: any) => {
            const cleanLine = line.replace(/^\s*[\u2022•\-]\s*/, '').trim();
            // Only add bullet if it's actual text content with meaningful length
            if (cleanLine && cleanLine.length > 1) {
              const wrappedText = doc.splitTextToSize(
                `• ${cleanLine}`,
                pageWidth - marginLeft * 2,
              );

              if (y > doc.internal.pageSize.getHeight() - 25) {
                doc.addPage();
                y = 25;
              }

              doc.text(wrappedText, marginLeft, y);
              y += wrappedText.length * 8;
            }
          });
        }
      }

      // doc.save(`${gameInfo.gameData.gameTitle} Keyinsights.pdf`);
      doc.save(`Project Echo ${questName} Key Insights.pdf`);
    };
    // const characterName =
    //   type === 'Dialog'
    //     ? data?.blockRoll === '9999'
    //       ? learnerPlayList?.mentorName ?? ''
    //       : data?.blockRoll === '99999'
    //       ? 'Narrator'
    //       : data?.blockRoll === '999999'
    //       ? learnerPlayList?.LearnerProfile?.nickName?.trim()
    //         ? learnerPlayList?.LearnerProfile?.nickName
    //         : learnerPlayList?.LearnerProfile?.name
    //       : NonPlayerNameLanguage
    //     : data?.blockResponseRoll === '99999'
    //     ? 'Narrator'
    //     : data?.blockResponseRoll === '999999'
    //     ? learnerPlayList?.LearnerProfile?.nickName?.trim()
    //       ? learnerPlayList?.LearnerProfile?.nickName
    //       : learnerPlayList?.LearnerProfile?.name
    //     : NonPlayerNameLanguage;

    // const rescharacterName =
    //   type === 'response'
    //     ? data?.blockRoll === '9999'
    //       ? learnerPlayList?.mentorName ?? ''
    //       : data?.blockResponseRoll === '99999'
    //       ? 'Narrator'
    //       : data?.blockResponseRoll === '999999'
    //       ? learnerPlayList?.LearnerProfile?.nickName?.trim() ||
    //         learnerPlayList?.LearnerProfile?.name ||
    //         ''
    //       : filteredCharacterGLBs.find(
    //           (glb: any) =>
    //             String(glb.uniqueId) === String(data?.blockResponseRoll),
    //         )?.assetType ||
    //         data?.blockResponseRoll ||
    //         ''
    //     : '';


    const characterName =
  type === 'Dialog'
    ? data?.blockRoll === '9999'
      ? learnerPlayList?.mentorName ||
        (learnerPlayList?.selectedmentor_charcter === 'MaleMentor'
          ? 'Zane'
          : learnerPlayList?.selectedmentor_charcter === 'FemaleMentor'
          ? 'Elara'
          : '')
      : data?.blockRoll === '99999'
      ? 'Narrator'
      : data?.blockRoll === '999999'
      ? learnerPlayList?.LearnerProfile?.nickName?.trim()
        ? learnerPlayList?.LearnerProfile?.nickName
        : learnerPlayList?.LearnerProfile?.name
      : NonPlayerNameLanguage
    : data?.blockResponseRoll === '99999'
    ? 'Narrator'
    : data?.blockResponseRoll === '999999'
    ? learnerPlayList?.LearnerProfile?.nickName?.trim()
      ? learnerPlayList?.LearnerProfile?.nickName
      : learnerPlayList?.LearnerProfile?.name
    : NonPlayerNameLanguage;


    const rescharacterName =
  type === 'response'
    ? data?.blockRoll === '9999'
      ? learnerPlayList?.mentorName ||
        (learnerPlayList?.selectedmentor_charcter === 'MaleMentor'
          ? 'Zane'
          : learnerPlayList?.selectedmentor_charcter === 'FemaleMentor'
          ? 'Elara'
          : '')
      : data?.blockResponseRoll === '99999'
      ? 'Narrator'
      : data?.blockResponseRoll === '999999'
      ? learnerPlayList?.LearnerProfile?.nickName?.trim() ||
        learnerPlayList?.LearnerProfile?.name ||
        ''
      : filteredCharacterGLBs.find(
          (glb: any) =>
            String(glb.uniqueId) === String(data?.blockResponseRoll),
        )?.assetType ||
        data?.blockResponseRoll ||
        ''
    : '';


    // DIALOG TEXT LOGIC (old UI)
    const dialogueText =
      type === 'Dialog' ? contentByLanguage || data?.blockText : resMsg;

    let imageName = '';
// kishore change the avathor icon and name
    if (type === 'Dialog') {
      if (data?.blockRoll === '9999') {
        const character = learnerPlayList?.selectedmentor_charcter?.trim();
     
       if (character === 'MaleMentor' || character === 'FuturisticMaleUser' || character === 'FutureThemeMale' || character === 'Zane') {
  imageName = MaleMentor;
} else if (character === 'FemaleMentor' || character === 'FuturisticFemaleUser' || character === 'FutureThemeFemale' || character === 'Elara') {
  imageName = FemaleMentor;
} else {
  imageName = narratoricon;
}
      } else if (data?.blockRoll === '99999') {
        imageName = narratoricon;
      } else if (data?.blockRoll === '999999') {
        const character = learnerPlayList?.selectedplayer_charcter?.trim();

        if (character === 'FuturisticMaleUser') {
          imageName = maleicon;
        } else if (character === 'FuturisticFemaleUser') {
          imageName = femaleicon;
        } else if (character === 'FutureThemeMale') {
          imageName = maleplayer2;
        } else if (character === 'FutureThemeMale1') {
          imageName = maleplayer3;
        } else if (character === 'FutureThemeFemale') {
          imageName = femaleplayer2;
        } else if (character === 'FutureThemeFemale1') {
          imageName = femaleplayer3;
        } else {
          imageName = narratoricon;
        }
      } else {
        const npc = scenarioNpc.find(
          (npc: any) => npc.gasId === Number(data?.blockRoll),
        );
        imageName = npcIconMap[npc?.gasId ?? -1] ?? narratoricon;
      }
    } else if (type === 'response') {
      if (data?.blockResponseRoll === '9999') {
        const character = learnerPlayList?.selectedmentor_charcter?.trim();
       if (character === 'MaleMentor' || character === 'FuturisticMaleUser' || character === 'FutureThemeMale' || character === 'Zane') {
  imageName = MaleMentor;
} else if (character === 'FemaleMentor' || character === 'FuturisticFemaleUser' || character === 'FutureThemeFemale' || character === 'Elara') {
  imageName = FemaleMentor;
} else {
  imageName = narratoricon;
}
      } else if (data?.blockResponseRoll === '99999') {
        imageName = narratoricon;
      } else if (data?.blockResponseRoll === '999999') {
        const character = learnerPlayList?.selectedplayer_charcter?.trim();

        if (character === 'FuturisticMaleUser') {
          imageName = maleicon;
        } else if (character === 'FuturisticFemaleUser') {
          imageName = femaleicon;
        } else if (character === 'FutureThemeMale') {
          imageName = maleplayer2;
        } else if (character === 'FutureThemeMale1') {
          imageName = maleplayer3;
        } else if (character === 'FutureThemeFemale') {
          imageName = femaleplayer2;
        } else if (character === 'FutureThemeFemale1') {
          imageName = femaleplayer3;
        } else {
          imageName = narratoricon;
        }
      } else {
        const npc = scenarioNpc.find(
          (npc: any) => npc.gasId === Number(data?.blockResponseRoll),
        );

        imageName = npcIconMap[npc?.gasId ?? -1] ?? narratoricon;
      }
    }

    const goLeft = () => handleBackClick(data);
    const goRight = () => Updatecontent();
    const updateAnswer = (e: any) => {
      const value = e.target.value;

      setAnswer(value);
      setRefQesAnswer({
        refqes1: value, // your backend key
      });
    };

    useEffect(() => {
      if (data && type) {
          const blockdata ={
            blockId: data.blockId,
            blockGameId: data.blockGameId,
            blockQuestNo: data.blockQuestNo,
            blockScenario: data.blockScenario,
            blockSecondaryId: data.blockSecondaryId,
            blockPrimarySequence: data.blockPrimarySequence,
            blockDragSequence: data.blockDragSequence,
            blockShowNavigate: data.blockShowNavigate,
            blockLeadTo: data.blockLeadTo,
            blockChoosen: data.blockChoosen,
            storyscreentype:type
          }
        
        if(["Note","Dialog","Link","Overview","KeyInsights","Interaction","Reflection","PostAssessment","PreAssessment","WehaveChoose","DragForNow","SwipeMiniGame"].includes(type)){
          setlearnerActivityrec((prev:any)=>
            createOrUpdateStoryBlock(
              prev,
               blockdata,
              deviceInfo
            )
          );
          if(type === "Reflection"){
            setlearnerActivityrec((prev:any)=>
            updateReflectionBlock(
              prev,
              {
                blockId:data.blockId,
                answers: answers,
                gameId: playingGameId,
                questNo: playingQuestNo,
                refansGameMode: 'game',
                blockSecondaryId: data.blockSecondaryId,
                learnerId: learnerPlayList.playerId
              },
              deviceInfo
            )
          );
          }
        }
        else if(["response"].includes(type)){
          setlearnerActivityrec((prev:any)=>
            createOrUpdateStoryBlock(
              prev,
              {
                ...blockdata,
                responsemsg: resMsg
              },
              deviceInfo
            )
          );
        }
        else if(["feedback"].includes(type)){
          setlearnerActivityrec((prev:any)=>
            createOrUpdateStoryBlock(
              prev,
              {
                ...blockdata,
                storyscreentype:type,
                feedbackmsg: feed
              },
              deviceInfo
            )
          );
        }
        setAudioObj((prev: any) => ({
          ...prev,
          url: '',
          type: EnumType.VOICE,
          loop: false, // Voice doesn't loop
          autoplay: true, // Autoplay is disabled
        }));
        setAnimateInteraction(false);
        setShowTypingEffect(false);
        setTimeout(() => {
          interactionNext === true && setInteractionNext(false);
        }, 1000);
        if (type === 'Note' || type === 'Dialog' || type === 'Interaction') {
          SetAudioOptions({ qpOptionId: '' });
        }
        if (profileData?.Audiogetlanguage.length !== 0) {
          const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
            (key: any) => key?.textId === formData?.gameId,
          );
          const BlockTextFilter = profileData?.Audiogetlanguage.filter(
            (key: any) => key?.textId === data?.blockId,
          );
          if (BlockTextFilter.length > 0) {
            const blockTextgetFiltered = BlockTextFilter.filter(
              (key: any) => key?.fieldName === 'blockText',
            );
            if (blockTextgetFiltered.length > 0) {
              const BlockTextContent = blockTextgetFiltered[0]?.content
                ? blockTextgetFiltered[0]?.content
                : null;
              setContentByLanguage(BlockTextContent);
            }
          }

          if (GameLanguageFilter.length > 0) {
            const NonPlayerGameFiltered = GameLanguageFilter.filter(
              (key: any) => key?.fieldName === 'gameNonPlayerName',
            );
            if (NonPlayerGameFiltered.length > 0) {
              const NonplayerName = NonPlayerGameFiltered[0]?.content
                ? NonPlayerGameFiltered[0]?.content
                : formData?.gameNonPlayerName;
              setNonPlayerNameLanguage(NonplayerName);
            }
          }
        } else {
          setContentByLanguage(data?.blockText);
        }
        if (gameInfo.hasOwnProperty('blocks')) {
          let previousPrimarySeq = navTrack[navTrack.length - 1];
          if (previousPrimarySeq) {
            let currentQuest = previousPrimarySeq.split('.')[0];
            let previousBlock: any = Object.values(
              gameInfo?.blocks[currentQuest],
            )?.find((row: any) => {
              return row.blockPrimarySequence === previousPrimarySeq;
            });
            if (data.blockPrimarySequence !== previousPrimarySeq) {
              const newArray = navTrack;
              newArray.push(data.blockPrimarySequence);
              setNavTrack(newArray);
            }
          } else {
            setNavTrack([data.blockPrimarySequence]);
          }
        }
      }
    }, [data, type]);

    useEffect(() => {
      setAnimateInteraction(false);
    }, []);
    useEffect(() => {
      if (animateInteraction === true) {
        setAnimateInteraction(false);
      }
    }, [animateInteraction]);
    const AudioDuration = (
      audio: any,
      audioUrl: any,
      gettype?: any,
      FindCurrentPlayingData?: any,
    ) => {
      const handleDuration = () => {
        const duration = audio.duration; // Duration in seconds

        let setWhospeaker: any = '';
        let setcharacteraction: any = '';
        let setcharacterName: any = '';
        if (
          !['response', 'feedback', 'Note'].includes(gettype) &&
          AudioOptions.qpOptionId === ''
        ) {
          setWhospeaker =
            FindCurrentPlayingData?.blockRoll === '9999'
              ? 'Mentor'
              : FindCurrentPlayingData.blockRoll === '99999' ||
                FindCurrentPlayingData.blockRoll === 'Narrator'
                ? 'Narrator'
                : FindCurrentPlayingData.blockRoll === '999999'
                  ? 'PC'
                  : 'NPC';
          // NonPlayerNameLanguage ? NonPlayerNameLanguage: '';

          setcharacteraction =
            FindCurrentPlayingData?.blockCharacterposesId ?? '';
        } else if (
          ['Note'].includes(gettype) &&
          AudioOptions.qpOptionId === ''
        ) {
          setWhospeaker = 'Narrator';
          setcharacteraction = '';
        } else if (
          ['Interaction'].includes(gettype) &&
          AudioOptions.qpOptionId !== ''
        ) {
          setWhospeaker = 'PC';
          setcharacteraction = FindCurrentPlayingData?.qpEmotion ?? '';
        } else if (
          ['response'].includes(gettype) &&
          AudioOptions.qpOptionId !== ''
        ) {
          setWhospeaker =
            FindCurrentPlayingData?.blockRoll === '9999'
              ? 'Mentor'
              : FindCurrentPlayingData.blockResponseRoll === '99999' ||
                FindCurrentPlayingData.blockRoll === 'Narrator'
                ? 'Narrator'
                : FindCurrentPlayingData.blockResponseRoll === '999999'
                  ? 'PC'
                  : 'NPC';
          setcharacteraction = FindCurrentPlayingData?.qpResponseEmotion ?? '';
        } else if (
          ['dialog'].includes(gettype) &&
          AudioOptions.qpOptionId !== ''
        ) {
          setWhospeaker =
            FindCurrentPlayingData?.blockRoll === '9999'
              ? 'Mentor'
              : FindCurrentPlayingData.blockResponseRoll === '99999' ||
                FindCurrentPlayingData.blockRoll === 'Narrator'
                ? 'Narrator'
                : FindCurrentPlayingData.blockResponseRoll === '999999'
                  ? 'PC'
                  : 'NPC';
          setcharacteraction = FindCurrentPlayingData?.qpResponseEmotion ?? '';
        } else if (
          ['feedback'].includes(gettype) &&
          AudioOptions.qpOptionId !== ''
        ) {
          // setWhospeaker = FindCurrentPlayingData.blockRoll === '99999' ? 'Narrator' : FindCurrentPlayingData.blockRoll === '999999' ? 'PC' : 'NPC';
          // setcharacteraction = '';
          setWhospeaker = 'Narrator';
          setcharacteraction = '';
        }
        SetGlbPlayingDetails({
          audioduration: duration,
          characteraction: setcharacteraction,
          whospeak: setWhospeaker,
        });

        // Clean up the object URL after use
        // URL.revokeObjectURL(audioUrl);
      };

      if (audio.readyState >= 1) {
        handleDuration();
      } else {
        audio.addEventListener("loadedmetadata", handleDuration, { once: true });
      }
    };
 
    useEffect(() => {
      return () => {
       
      };
    }, [data, type, AudioOptions]);
 
    const getCachedAudio = (path: any) => {
    
      if (!path) return null;
      const cachedUrl = audioCache[path];
    
      if (!cachedUrl) {
        console.warn("Audio not preloaded:", path);
        return null;
      }
      return cachedUrl;
    };

    const fetchData = async () => {
      if (profileData?.Audiogetlanguage.length !== 0) {
        const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === formData?.gameId,
        );
        const BlockTextFilter = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === data?.blockId,
        );
        if (BlockTextFilter.length > 0) {
          const blockTextgetFiltered = BlockTextFilter.filter(
            (key: any) => key?.fieldName === 'blockText',
          );
          if (blockTextgetFiltered.length > 0) {
            const BlockTextContent = blockTextgetFiltered[0]?.content;
            setContentByLanguage(BlockTextContent);
          }
        }

        if (GameLanguageFilter.length > 0) {
          const NonPlayerGameFiltered = GameLanguageFilter.filter(
            (key: any) => key?.fieldName === 'gameNonPlayerName',
          );
          if (NonPlayerGameFiltered.length > 0) {
            const NonplayerName = NonPlayerGameFiltered[0]?.content
              ? NonPlayerGameFiltered[0]?.content
              : formData?.gameNonPlayerName;
            setNonPlayerNameLanguage(NonplayerName);
          }
        }
        setAudioObj((prev: any) => ({
          ...prev,
          url: '',
          type: EnumType.VOICE,
          loop: false, // Voice doesn't loop
          autoplay: true, // Autoplay is disabled
        }));

        if (
          AudioOptions.qpOptionId === '' &&
          (type === 'Note' || type === 'Dialog' || type === 'Interaction')
        ) {
          const GetblocktextAudioFiltered =
            profileData?.Audiogetlanguage.filter(
              (key: any) => key?.textId === data?.blockId,
            );
          if (GetblocktextAudioFiltered.length > 0) {
            const FilteredFieldName = GetblocktextAudioFiltered.map(
              (item: any) => item.fieldName,
            );
            const Filteredcontent = GetblocktextAudioFiltered.map(
              (item: any) => item.content,
            );

            if (FilteredFieldName[0] === 'blockText') {
              try {
                const normalizedPath = GetblocktextAudioFiltered[0]?.audioUrls
                  ? GetblocktextAudioFiltered[0]?.audioUrls
                  : '';
                if (normalizedPath !== '') {
                  const fullUrl = `${API_SERVER}${normalizedPath}`;

                  const responseblockText = await fetch(fullUrl);
                  if (responseblockText.ok) {
                    setAudioObj((prev: any) => ({
                      ...prev,
                      url: fullUrl,
                      type: EnumType.VOICE,
                      loop: false, // Voice doesn't loop
                      autoplay: true, // Autoplay is disabled
                    }));
                    const audioBlob = await responseblockText.blob();
                    // Create a URL for the Blob
                    const audioUrl = URL.createObjectURL(audioBlob);

                    // Create an Audio element and set the source to the Blob URL
                    const audio = new Audio(audioUrl);
                    SetGlbPlayingDetails({
                      audioduration: audio.duration,
                      characteraction: data.blockCharacterposesId,
                      whospeak:
                        data?.blockRoll === '9999'
                          ? 'Mentor'
                          : data.blockRoll === '99999'
                            ? 'Narrator'
                            : data.blockRoll === '999999'
                              ? 'PC'
                              : 'NPC',
                    });
                  }
                }
              } catch (error) {
                console.error('Error fetching data:', error);
              }
            }
          }
        } else {
          if (AudioOptions.qpOptionId) {
            const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
              (key: any) => key?.textId === AudioOptions?.qpOptionId,
            );
            if (optionAudioFiltered.length > 0) {
              const getoptionsAudioFiltered = optionAudioFiltered.filter(
                (key: any) => key?.fieldName === 'qpOptionText',
              );
              const responseAudioFiltered = optionAudioFiltered.filter(
                (key: any) => key?.fieldName === 'qpResponse',
              );
              const FeedBackAudioFiltered = optionAudioFiltered.filter(
                (key: any) => key?.fieldName === 'qpFeedback',
              );
              if (type === 'Interaction') {
                if (getoptionsAudioFiltered.length > 0) {
                  try {
                    const normalizedPath = getoptionsAudioFiltered[0]?.audioUrls
                      ? getoptionsAudioFiltered[0]?.audioUrls
                      : '';
                    if (normalizedPath !== '') {
                      const qpOptionTextUrl = `${API_SERVER}${normalizedPath}`;
                      const responseqpOptionText = await fetch(qpOptionTextUrl);
                      if (responseqpOptionText.ok) {
                        setAudioObj((prev: any) => ({
                          ...prev,
                          url: qpOptionTextUrl,
                          type: EnumType.VOICE,
                          // volume: '0.5',
                          loop: false,
                          autoplay: true,
                        }));
                      }
                    }
                  } catch (error) {
                    console.error('Error fetching data:', error);
                  }
                }
              } else if (type === 'response') {
                if (responseAudioFiltered.length > 0) {
                  try {
                    const normalizedPath = responseAudioFiltered[0]?.audioUrls
                      ? responseAudioFiltered[0]?.audioUrls
                      : '';

                    if (normalizedPath !== '') {
                      const qRespOptionTextUrl = `${API_SERVER}${normalizedPath}`;

                      const responseqpOptionText = await fetch(
                        qRespOptionTextUrl,
                      );
                      if (responseqpOptionText.ok) {
                        setAudioObj((prev: any) => ({
                          ...prev,
                          url: qRespOptionTextUrl,
                          type: EnumType.VOICE,
                          // volume: '0.5',
                          loop: false,
                          autoplay: true,
                        }));
                      }
                    }
                  } catch (error) {
                    console.error('Error fetching data:', error);
                  }
                }
              } else if (type === 'feedback') {
                if (FeedBackAudioFiltered.length > 0) {
                  try {
                    const normalizedPath = FeedBackAudioFiltered[0]?.audioUrls
                      ? FeedBackAudioFiltered[0]?.audioUrls
                      : '';
                    if (normalizedPath !== '') {
                      const qFeedTextUrl = `${API_SERVER}${normalizedPath}`;
                      const FeedBackOptionText = await fetch(qFeedTextUrl);
                      if (FeedBackOptionText.ok) {
                        setAudioObj((prev: any) => ({
                          ...prev,
                          url: qFeedTextUrl,
                          type: EnumType.VOICE,
                          // volume: '0.5',
                          loop: false,
                          autoplay: true,
                        }));
                      }
                    }
                  } catch (error) {
                    console.error('Error fetching data:', error);
                  }
                }
              }
            }
          }
        }
      } else {
       
        if (data && type) {
          if (
            ['Note', 'Dialog', 'Interaction'].includes(type) &&
            AudioOptions?.qpOptionId === ''
          ) {
            if (!['999999', '9999'].includes(data?.blockRoll)) {
              try {
                const NonplayerName =
                  data?.blockRoll === '9999'
                    ? {
                      gasId: null,
                      name: 'mentor',
                    }
                    : data?.blockRoll === 'Narrator'
                      ? {
                        gasId: null,
                        name: 'Narrator',
                      }
                      : scenarioNpc.find(
                        (npc: any) => npc.gasId === Number(data?.blockRoll),
                      ) ?? {
                        gasId: null,
                        name: '',
                      };

                setNonPlayerNameLanguage(NonplayerName?.name);
                setNonPlayerNameLanguageId(NonplayerName?.gasId);
                const normalizedPath = data?.blockAudioUrl
                  ? data?.blockAudioUrl
                  : '';
                if (normalizedPath !== '') {
                
                  const fullUrl = getCachedAudio(normalizedPath);
              
                  // const fullUrl = `${API_SERVER}${normalizedPath}`;

                  // const responseblockText = await fetch(fullUrl);

                  if (fullUrl) {
                    setAudioObj((prev: any) => ({
                      ...prev,
                      url: fullUrl.src,
                      type: EnumType.VOICE,
                      loop: false, // Voice doesn't loop
                      autoplay: true, // Autoplay is disabled
                    }));
                    AudioDuration(fullUrl, fullUrl.src, type, data);
                   
                  }
                }
              } catch (error) {
                console.error('Error fetching data:', error);
              }
            } else {
              if (data?.blockRoll === '999999') {
                if (
                  (profileData && 'gender' in profileData) ||
                  learnerPlayList.player_gender
                ) {
                  if (
                    learnerPlayList.player_gender
                      ? learnerPlayList.player_gender === 'male'
                      : ['Male', 'male', 'Others'].includes(profileData?.gender)
                  ) {
                    try {
                      const normalizedPath = data?.blockAudioUrl
                        ? data?.blockAudioUrl
                        : '';
                      if (normalizedPath !== '') {
                        // const fullUrl = `${API_SERVER}${normalizedPath}`;
                        // const responseblockText = await fetch(fullUrl);
                      
                        const fullUrl = getCachedAudio(normalizedPath);
                       
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, data);
                        
                        }
                      }
                    } catch (error) {
                      console.error('Error fetching data:', error);
                    }
                  } else if (
                    profileData?.gender === 'Female' ||
                    'female' ||
                    learnerPlayList.player_gender === 'female'
                  ) {
                    try {
                      const normalizedPath = data?.blockAudioUrlFemale
                        ? data?.blockAudioUrlFemale
                        : '';
                      if (normalizedPath !== '') {
                        // const fullUrl = `${API_SERVER}${normalizedPath}`;
                        // const responseblockText = await fetch(fullUrl);
                     
                        const fullUrl = getCachedAudio(normalizedPath);
                       
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, data);
                       
                        }
                      }
                    } catch (error) {
                      console.error('Error fetching data:', error);
                    }
                  }
                }
              } else if (data?.blockRoll === '9999') {
                if (learnerPlayList.mentor_gender) {
                  if (
                    learnerPlayList.mentor_gender === 'male' ||
                    learnerPlayList.mentor_gender === 'Male'
                  ) {
                    try {
                      const normalizedPath = data?.blockAudioUrl
                        ? data?.blockAudioUrl
                        : '';
                      if (normalizedPath !== '') {
                      
                        // const fullUrl = `${API_SERVER}${normalizedPath}`;
                        // const responseblockText = await fetch(fullUrl);
                        const fullUrl = getCachedAudio(normalizedPath);
                  
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, data);
                        
                        }
                      }
                    } catch (error) {
                      console.error('Error fetching data:', error);
                    }
                  } else if (
                    learnerPlayList.mentor_gender === 'female' ||
                    learnerPlayList.mentor_gender === 'Female'
                  ) {
                    try {
                      const normalizedPath = data?.blockAudioUrlFemale
                        ? data?.blockAudioUrlFemale
                        : '';
                      if (normalizedPath !== '') {
                      
                        // const fullUrl = `${API_SERVER}${normalizedPath}`;
                        // const responseblockText = await fetch(fullUrl);
                        const fullUrl = getCachedAudio(normalizedPath);
                      
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, data);
                          
                        }
                      }
                    } catch (error) {
                      console.error('Error fetching data:', error);
                    }
                  }
                }
              }
            }
          } else if (AudioOptions?.qpOptionId !== '') {
            const FindUrl = options?.filter(
              (item: any) => AudioOptions?.qpOptionId === item?.qpOptionId,
            );

            if (FindUrl?.length > 0) {
              try {
                if (type === 'Interaction') {
                  if (
                    (profileData && 'gender' in profileData) ||
                    learnerPlayList.player_gender
                  ) {
                    if (
                      learnerPlayList.player_gender
                        ? learnerPlayList.player_gender === 'male'
                        : ['male', 'Male', 'Others'].includes(
                          profileData?.gender,
                        )
                    ) {
                      const optionAudio = FindUrl[0]?.qbAudioUrl
                        ? FindUrl[0]?.qbAudioUrl
                        : '';
                      if (optionAudio !== '') {
                       
                        const fullUrl = getCachedAudio(optionAudio);
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, FindUrl[0]);
                         
                        }
                      }
                    } else {
                      const optionAudio = FindUrl[0]?.qbAudioUrlFemale
                        ? FindUrl[0]?.qbAudioUrlFemale
                        : '';
                      if (optionAudio !== '') {
                        // const fullUrl = `${API_SERVER}${optionAudio}`;
                        // const responseblockText = await fetch(fullUrl);
                        const fullUrl = getCachedAudio(optionAudio);
                        if (fullUrl) {
                          setAudioObj((prev: any) => ({
                            ...prev,
                            url: fullUrl.src,
                            type: EnumType.VOICE,
                            loop: false, // Voice doesn't loop
                            autoplay: true, // Autoplay is disabled
                          }));
                          AudioDuration(fullUrl, fullUrl.src, type, FindUrl[0]);
                         
                        }
                      }
                    }
                  }
                } else if (type === 'response') {
                  const optionResponseAudio = FindUrl[0]?.qbResponseAudioUrl
                    ? FindUrl[0]?.qbResponseAudioUrl
                    : '';

                  if (optionResponseAudio !== '') {
                    // const fullUrl = `${API_SERVER}${optionResponseAudio}`;
                    // const responseblockText = await fetch(fullUrl);
                    const fullUrl = getCachedAudio(optionResponseAudio);
                    if (fullUrl) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: fullUrl.src,
                        type: EnumType.VOICE,
                        loop: false, // Voice doesn't loop
                        autoplay: true, // Autoplay is disabled
                      }));
                      AudioDuration(fullUrl, fullUrl.src, type, FindUrl[0]);
                      
                    }
                  }
                } else if (type === 'feedback') {
                  const optionFeedBackAudio = FindUrl[0]?.qbfeedbackAudioUrl
                    ? FindUrl[0]?.qbfeedbackAudioUrl
                    : '';
                  if (optionFeedBackAudio !== '') {
                    // const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
                    // const responseblockText = await fetch(fullUrl);
                    const fullUrl = getCachedAudio(optionFeedBackAudio);
                    if (fullUrl) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: fullUrl.src,
                        type: EnumType.VOICE,
                        loop: false, // Voice doesn't loop
                        autoplay: true, // Autoplay is disabled
                      }));
                      AudioDuration(fullUrl, fullUrl.src, type, FindUrl[0]);
                    
                    }
                  }
                }
              } catch (error) {
                console.error('Error fetching data:', error);
              }
            }
          }
        }
      }
    };


   useEffect(() => { 
    if(type === 'ScenarioCompletion'){
      
    }
  if (
  type === 'ScenarioCompletion' &&
  data?.blockScenario &&
  onScenarioCompleted &&
  (
    currentReplayInfo?.scenarioName === data.blockScenario ||
    questState[data.blockQuestNo] === "replayallowed"
  )
) {
   
  setOptionalReplayTracked(false)
  onScenarioCompleted(data.blockScenario, data.blockQuestNo);
}
}, [type, data?.blockScenario]); 


 useEffect(() => {
      if (isDoorEntry) return;  
      if(isLoading) return;
      if(showScenarioTransition) return;
        fetchData();
    
    }, [isDoorEntry]);



   useEffect(() => {

    //  if (showScenarioTransition) return; 
       if (isDoorEntry) return;  
       if(isLoading) return;
       if(showScenarioTransition) return;
      fetchData();
   
  }, [ data, type, AudioOptions, modalLoaded, isLoading, showScenarioTransition,isDoorEntry]);


    useEffect(() => {}, [learnerPlayList.firstTryScore]);

    const InteractionFunction = () => {
      setAnimateInteraction(true);
 setlearnerActivityrec((prev:any)=>
        updateInteractionBlock(
          prev,
          {
            blockId:data.blockId,
            selectedoption:score?.selectedOptioncheck,
            score:score?.score,
            response:resMsg,
            feed:feed
          },
          deviceInfo
        )
      );
      setTimeout(async() => {
        const currentDateTime = new Date();
        const day = String(currentDateTime.getDate()).padStart(2, '0');
        const month = String(currentDateTime.getMonth() + 1).padStart(2, '0');
        const year = String(currentDateTime.getFullYear());
        const currentDate = `${day}-${month}-${year}`;

        // ✅ Avoid running if score not yet chosen
        if (!score || !score.seqId) {
          setInteractionNext(true);
          return;
        }

        const { seqId, score: newScore, selectedOptioncheck } = score;
        const questNo = parseInt(seqId.split('.')[0]);

        // Determine replay/first try mode
        const isReplay =
          Object.keys(questState).length > 0 &&
          questState[profile?.currentQuest] === 'replayallowed';


  const scenarioId =
          typeof data.blockScenario === 'string'
            ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
            : data.blockScenario;


        // ✅ Update score or replayScore safely
        setProfile((prev: any) => {
          const targetList = isReplay ? prev.replayScore : prev.score;
          const idx = targetList.findIndex((i: any) => i.seqId === seqId);
          const updatedList = [...targetList];
          const numericScore = Number(newScore || 0);

          if (idx !== -1) {
            // Update existing score safely
            updatedList[idx] = {
              ...updatedList[idx],
              score: RepeatSelectOption ? updatedList[idx].score : numericScore,
              choosedoption: selectedOptioncheck,
              quest: questNo,
              scoreEarnedDate: currentDate,
                 scenarioId: scenarioId,
            };
          } else {
            // Add new score entry
            updatedList.push({
              seqId,
              score: numericScore,
              choosedoption: selectedOptioncheck,
              quest: questNo,
              scoreEarnedDate: currentDate,
                 scenarioId: scenarioId,
            });

            // ✅ Only push first try to learnerPlayingDetails
            // if (!isReplay) {
            //   setLearnerPlayingDetails((prevPlay: any) => ({
            //     ...prevPlay,
            //     firstTryScore: [
            //       ...prevPlay.firstTryScore,
            //       { seqId, quest: questNo, score: numericScore },
            //     ],
            //   }));
            // }
            if (!isReplay) {
  setLearnerPlayingDetails((prevPlay: any) => {
    const alreadyExists = prevPlay.firstTryScore.some(
      (item: any) => item.seqId === seqId
    );
    if (alreadyExists) return prevPlay;

    return {
      ...prevPlay,
      firstTryScore: [
        ...prevPlay.firstTryScore,
        { seqId, quest: questNo, score: numericScore },
      ],
    };
  });
}
          }

          return {
            ...prev,
            [isReplay ? 'replayScore' : 'score']: updatedList,
          };
        });

        // ✅ Fully reset temporary state after saving
        if (typeof setScore === 'function') {
          setScore({
            seqId: null,
            score: null,
            selectedOptioncheck: null,
          });
        }
//  fetchblockScore(score);
 const interactionScore = await fetchblockScore(score);
    setLastInteractionScore(interactionScore);
        // ✅ Proceed to next question
        setInteractionNext(true);
      }, 600);
    };
    useEffect(() => {
      if (interactionNext === true) {
        setInteractionNext(false);
        getData(data);
      }
    }, [interactionNext]);
    const [prevSelectOption, setPrevselectoptions] = useState<any>([]);
    const optionClick = (item: any) => {
       if (isAudioPaused) {
    toggleAudioPlayPause();
  }
      let updatedscore: any = [];

      const currentQuest = parseInt(profile?.currentQuest);

      if (questState[currentQuest] === 'Started') {
        updatedscore = profile?.score;
      } else if (questState[currentQuest] === 'replayallowed') {
        updatedscore = profile?.replayScore;
      }

      if (updatedscore.length > 0 && !RepeatSelectOption) {
        let getOption: any = [];
        if (questState[currentQuest] === 'Started') {
          getOption = profile?.score?.find(
            (opt: any) => opt?.seqId == data?.blockPrimarySequence,
          );
        } else if (questState[currentQuest] === 'replayallowed') {
          getOption = profile?.replayScore?.find(
            (opt: any) => opt?.seqId == data?.blockPrimarySequence,
          );
        }

        if (!getOption) {
          if (
            score?.selectedOptioncheck !== item?.qpOptions &&
            score?.seqId !== item?.qpSequence
          ) {
            // ✅ first-time: update all fields
            setScore({
              seqId: item?.qpSequence,
              score: parseInt(item?.qpScore),
              selectedOptioncheck: item?.qpOptions,
            });
          } else if (RepeatSelectOption) {
            // Repeat question => update only seqId & selected option, do NOT touch score
            setScore((prev: any) => ({
              ...prev,
              seqId: item?.qpSequence,
              selectedOptioncheck: item?.qpOptions,
            }));
          } else {
            // Default fallback (first-time for this session)
            setScore({
              seqId: item?.qpSequence,
              score: parseInt(item?.qpScore),
              selectedOptioncheck: item?.qpOptions,
            });
          }

          SetAudioOptions(item);
          handleValidate(item);
        }

        if (!getOption && RepeatPrevOption) {
        }
      } else {
        if (
          score?.selectedOptioncheck !== item?.qpOptions &&
          score?.seqId !== item?.qpSequence
        ) {
          // ✅ first-time or new block: update all fields
          setScore({
            seqId: item?.qpSequence,
            score: parseInt(item?.qpScore),
            selectedOptioncheck: item?.qpOptions,
          });
        } else if (RepeatSelectOption) {
          // Repeat question => update only seqId & selected option, do NOT touch score
          setScore((prev: any) => ({
            ...prev,
            seqId: item?.qpSequence,
            selectedOptioncheck: item?.qpOptions,
          }));
        } else {
          // Default fallback (first-time for this session)
          setScore({
            seqId: item?.qpSequence,
            score: parseInt(item?.qpScore),
            selectedOptioncheck: item?.qpOptions,
          });
        }

        SetAudioOptions(item);
        handleValidate(item);
      }
    };

   

  const [showQuestTransition, setShowQuestTransition] = useState(false);
    useEffect(() => {
  const shouldTrigger = sessionStorage.getItem("showQuestTransition");

  if (shouldTrigger === "true") {
    setShowQuestTransition(true);
    sessionStorage.removeItem("showQuestTransition");
  }
}, []);

    const questData: Record<number, { label: string; title: string }> = {
      1: { label: "QUEST 1", title: "VISION DECK" },
      2: { label: "QUEST 2", title: "OPS BAY" },
      3: { label: "QUEST 3", title: "COGNITION CHAMBER" },
      4: { label: "QUEST 4", title: "QUANTUM ATRIUM" },
    };

    const quest = questData[profile?.currentQuest] || questData[1];
  const doorEntryHasStarted = useRef(false);

    useEffect(() => {
      if (isDoorEntry) {
        doorEntryHasStarted.current = true;
      }
    }, [isDoorEntry]);
    // 3. Trigger it when loading completes (wherever you set isLoading = false)
    useEffect(() => {
      if (loadingProgress >= 100) {
        setShowQuestTransition(true);
      }
    }, [loadingProgress]);
  useEffect(() => {
   
    if (nextcharacter === "WALK_OUT_COMPLETE") {
      setNextcharacter("WALK_IN_QUEUED");

      if (upComingBlockChoosen !== 'Dialog') {
        setAnimateDialog(true);
        // setTimeout(() => {
        //   getData(data);
        // }, 500);
      } else {
        // getData(data);
      }
    } else if (nextcharacter === "WALK_IN_COMPLETE") {
      setNextcharacter("");
      setWalkanimation(false);
    }
  }, [nextcharacter,nextcharactervoice]);

  const Updatecontent = () => {
    // Check if the current block dictates a walk animation
    if (data.blockCharacterposesId && !nextcharacter) {
      const emotion = data.blockCharacterposesId?.trim()?.toUpperCase() || '';
      const multiAction: any = emotion.split(',').map((action: any) => action.trim());
     
      if (multiAction.length > 0) {
        const findindex = multiAction.findIndex((action: any) => action.trim() === 'WALK2');
      

        if (findindex > -1) {
          // Trigger the walk animation, which will cue the character to walk right to center.
          // Because `setWalkanimation(true)` is set, we will NOT call `getData` here.
          // We wait until `FutureThemeWorkshop.js` finishes the walk and sets `nextcharacter("")` and `walkanimation(false)`.
          setWalkanimation(true);
          return;
        }
      }
    }

    // Default behavior if no walk animation is required
    if (!showTypingEffect) {
      setShowTypingEffect(true);
    }

    if (upComingBlockChoosen !== 'Dialog') {
      setAnimateDialog(true);
      setTimeout(() => {
        getData(data);
      }, 500);
    } else {
      getData(data);
    }
  };
    useEffect(() => {
      setAnimateNote(false);
      setAnimateDialog(false);
      setAnimateInteraction(false);
      setAnimateFeedback(false);
    }, [data, type, showTypingEffect, upComingBlockChoosen]);

    const getNoteNextData = () => {
      setAnimateNote(true);
      setTimeout(() => {
        getData(data);
      }, 500);
    };



    // by jaswanth - sound effect (reflection)


    const soundMap: Record<string, (ctx: AudioContext) => void> = {
      Reflection: playReflection,
      Link: playNugget,
      PostAssessment: playAssessment,
      PreAssessment: playAssessment,

    };

    useEffect(() => {
      if (!type) return;

      const audioCtx = new AudioContext();

      const playSound = soundMap[type];

      if (playSound) {
        playSound(audioCtx);
      }

      return () => {
        audioCtx.close();
      };
    }, [type]);

    function playReflection(ctx: AudioContext) {
      const now = ctx.currentTime;

      [400, 550].forEach((freq, i) => {
        const t = now + i * 0.08;

        const osc = ctx.createOscillator();
        const gain = ctx.createGain();

        osc.type = "sine";
        osc.frequency.setValueAtTime(freq, t);

        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.15, t + 0.005);
        gain.gain.linearRampToValueAtTime(0, t + 0.07);

        osc.connect(gain);
        gain.connect(ctx.destination);

        osc.start(t);
        osc.stop(t + 0.08);
      });
    }

    function playNugget(ctx: AudioContext) {
      const now = ctx.currentTime;
      [880, 660, 528].forEach((freq, i) => {
        const t = now + i * 0.06;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.15, t + 0.004);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.18);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(t);
        osc.stop(t + 0.19);
      });
    }

    function playAssessment(ctx: AudioContext) {
      const now = ctx.currentTime;
      [660, 880].forEach((freq, i) => {
        const t = now + i * 0.07;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.15, t + 0.003);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.1);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(t);
        osc.stop(t + 0.11);
      });
    }

        //new kaviya - for animation audio
    //this is for reflection 
   //const audioRef = useRef(null);

//useEffect(() => {
  //audioRef.current = new Audio(animationSound);
  //audioRef.current.volume = 1;
  //audioRef.current.preload = "auto"; // preload the audio
//}, []);
//useEffect(() => {
 // const unlockAudio = () => {
  //  if (audioRef.current) {
    //  audioRef.current.play()
        //.then(() => {
        //  audioRef.current.pause();
      //    audioRef.current.currentTime = 0;
    //    })
  //      .catch(() => {});
  //  }
 //   document.removeEventListener("click", unlockAudio);
//  };

  //document.addEventListener("click", unlockAudio);
//}, []);

    const zoomAudioRef = useRef(null);

    useEffect(() => {
      zoomAudioRef.current = new Audio(zoomSound); // your sound file
      zoomAudioRef.current.volume = 1;
    }, []);
    const playZoomSound = () => {
      if (!zoomAudioRef.current) return;
      zoomAudioRef.current.currentTime = 0;
      zoomAudioRef.current.play().catch(() => { });
    };

    const stopZoomSound = () => {
      if (!zoomAudioRef.current) return;
      zoomAudioRef.current.pause();
      zoomAudioRef.current.currentTime = 0;
    };

    const flipAudioRef = useRef(null);

    useEffect(() => {
      flipAudioRef.current = new Audio(flipSound); // your sound file
      flipAudioRef.current.volume = 1;
    }, []);

    const playFlipSound = () => {
      if (!flipAudioRef.current) return;

      flipAudioRef.current.currentTime = 0;
      flipAudioRef.current.play().catch(() => { });
    };

    const stopFlipSound = () => {
      if (!flipAudioRef.current) return;

      flipAudioRef.current.pause();
      flipAudioRef.current.currentTime = 0;
    };

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

const hasShownReflectionNote = useRef(false);
    //new State by kaviya 
    const [showReflectionNote, setShowReflectionNote] = useState(true);

    const [answers, setAnswer] = useState<string>('');
    const [RefQesAnswer, setRefQesAnswer] = useState<any>([]);
    const playingGameId = learnerPlayList?.GameId;
    const playingQuestNo = learnerPlayList?.PlayerScore_Level?.currentQuest;
    useEffect(() => {
      setAnswer(data?.blockrefanswer);
    }, [data?.blockrefanswer]);
    const handleBackClick = (data: any) => {

      if (isButtonDisabled) return; // prevent double click

      setIsButtonDisabled(true); // ## disable both arrows

      LastModiPrevData(data); // ## previous nav logic

      setTimeout(() => {
        setIsButtonDisabled(false); // ## re-enable after delay
      }, 500); // delay in ms
   
    };

    const upNext = () => {
      setAnimateFeedback(true);
      setTimeout(() => {
        getData(data);
      }, 500);
    };
    const parseSequence = (seq: any) => {
      return seq.split('.').map(Number);
    };
    const findPreviousSequence = (array: any, currentSeq: any) => {
      const parsedCurrentSeq = parseSequence(currentSeq);
      let previousSeq = null;
      if (array) {
        for (let obj of array) {
          const parsedSeq = parseSequence(obj.blockPrimarySequence);

          if (
            parsedSeq[0] === parsedCurrentSeq[0] &&
            parsedSeq[1] < parsedCurrentSeq[1]
          ) {
            if (
              !previousSeq ||
              parsedSeq[1] > parseSequence(previousSeq.blockPrimarySequence)[1]
            ) {
              previousSeq = obj;
            }
          }
        }
        return previousSeq;
      } else {
        return previousSeq;
      }
    };
    const blockPrimarySequenceParts = data?.blockPrimarySequence.split('.');
    const primaryKey = blockPrimarySequenceParts
      ? parseInt(blockPrimarySequenceParts[0])
      : null;
    const valuesArray =
      gameInfo.blocks && gameInfo.blocks[primaryKey]
        ? Object.values(gameInfo.blocks[primaryKey])
        : null;
    const previousSeqObj = findPreviousSequence(
      valuesArray,
      data?.blockPrimarySequence,
    );
    const checkInfo =
      primaryKey && gameInfo?.blocks && gameInfo?.blocks[primaryKey]
        ? Object.values(gameInfo?.blocks[primaryKey])?.some((item: any) => {
            return item?.blockPrimarySequence === data?.blockPrimarySequence;
          })
        : null;
    let CheckPreviousData = null;
    if (checkInfo) {
      CheckPreviousData = data?.blockPrimarySequence;
    } else {
      CheckPreviousData = previousSeqObj?.blockPrimarySequence;
    }
    const sequenceMatches =
      primaryKey !== null &&
      gameInfo.blocks.hasOwnProperty(primaryKey) &&
      CheckPreviousData ===
        gameInfo.blocks[primaryKey]?.['1']?.blockPrimarySequence;
    useEffect(() => {
      if (type === 'Note') {
        setBasedOnNDI('top center');
      }
      if (type === 'Dialog') {
        setBasedOnNDI('right bottom');
      }
      if (type === 'Interaction') {
        setBasedOnNDI('center bottom');
      }
    }, [type]);
    // Determine if this note is the first or last in the current sequence
    let isFirstNote = false;
    let isLastNote = false;

    if (
      type === 'Note' &&
      primaryKey !== null &&
      gameInfo.blocks?.[primaryKey]
    ) {
      const sequenceArray = Object.values(gameInfo.blocks[primaryKey]).sort(
        (a: any, b: any) => {
          const aPart = parseInt(a.blockPrimarySequence.split('.')[1]);
          const bPart = parseInt(b.blockPrimarySequence.split('.')[1]);
          return aPart - bPart;
        },
      );

      const currentIndex = sequenceArray.findIndex(
        (item: any) => item.blockPrimarySequence === data?.blockPrimarySequence,
      );

      isFirstNote = currentIndex === 0;
      isLastNote = currentIndex === sequenceArray.length - 1;
    }

    const hasAnswer = answers?.trim()?.length > 0;

    const nextNavigation = async () => {
       setlearnerActivityrec((prev:any)=>
        updateReflectionBlock(
          prev,
          {
            blockId:data.blockId,
            answers: answers,
            gameId: playingGameId,
            questNo: playingQuestNo,
            refansGameMode: 'game',
            blockSecondaryId: data.blockSecondaryId,
            learnerId: learnerPlayList.playerId
          },
          deviceInfo
        )
      );
      const data1 = {
        answers: RefQesAnswer,
        gameId: playingGameId,
        questNo: playingQuestNo,
        refansGameMode: 'game',
        blockSecondaryId: data.blockSecondaryId,
         learnerId: learnerPlayList.playerId
      };

      //new by kaviya 
  //    if (type === "Reflection" && showReflectionNote) {
  //    setTimeout(() => {
  //       setShowReflectionNote(false);
  //     }, 400);
  // }
      try {
        const result = await storeRefqes(JSON.stringify(data1));

        if (result.status === 'Success') {
          getData(data);
        }
      } catch (error) {
        console.error('Error saving reflection:', error);
      }
    };
useEffect(() => {
  if (type === "Reflection") {
    if (!hasShownReflectionNote.current) {
      setShowReflectionNote(true);
      hasShownReflectionNote.current = true; // mark as shown
    } else {
      setShowReflectionNote(false);
    }
  }
}, [data?.blockId]); // or block change trigger // or whatever uniquely identifies your block
    const fetchreqans = async () => {
      const data2 = {
        gameId: playingGameId,
        questNo: playingQuestNo,
        blockSecondaryId: data.blockSecondaryId,
      };

      try {
        const result = await storeRefqes1(JSON.stringify(data2));

        if (result.status === 'Success') {
          setAnswer(result?.data?.refansAnswer || '');
        }
      } catch (error) {
        console.error('Error saving reflection:', error);
      }
    };

const [isPopupNextFlow, setIsPopupNextFlow] = useState(false);
    const [allLearnerScenarioScore, setAllLearnerScenarioScore] =
      useState<any>(null);

  //   const AllLearnerLearderboard = async () => {

  //      if (isPopupNextFlow) {
  //   setIsPopupNextFlow(false); 
  //   return;
  // }
  //     const payload = {
  //       gameId: data?.blockGameId,
  //       scenario: data?.blockScenario,
  //       questNo: data?.blockQuestNo,
  //     };

  //     if (!payload.gameId) {
  //       console.error('INVALID PAYLOAD', payload);
  //       return;
  //     }

  //     const result = await AllLearnerscenarioLearderboard(
  //       JSON.stringify(payload),
  //     );

  //     if (result?.status === 'Success') {
  //       setAllLearnerScenarioScore(result.data);
  //     } else {
  //       setAllLearnerScenarioScore([]);
  //     }
  //   };

    // useEffect(() => {
    //   if (data?.blockGameId && data?.blockScenario && data?.blockQuestNo) {
    //     AllLearnerLearderboard();
    //   } else {
    //   }
    // }, [data]);

    useEffect(() => {
      if (playingGameId && playingQuestNo && data?.blockSecondaryId && data?.blockSecondaryId && type==="Reflection") {
        fetchreqans();
      }
    }, [data?.blockSecondaryId]);
    // Put this at the top of your component (inside the function body but outside return)

    const DoorToast = ({
      message,
      onClick,
    }: {
      message: string;
      onClick: () => void;
    }) => (
      <Box
        position="absolute"
        top="80"
        left="50%"
        transform="translateX(-50%)"
        minW="160px"
        maxW="260px"
        px="16px"
        py="12px"
        textAlign="center"
        borderRadius="10px"
        fontSize="12px"
        fontWeight="600"
        letterSpacing="0.4px"
        whiteSpace="normal"
        zIndex={1000}
        bg="rgba(10, 15, 30, 0.9)"
        color="#3CFFC6"
        border="2px solid #3CFFC6"
        backdropFilter="blur(6px)"
        boxShadow="
      0 0 10px rgba(60,255,198,0.8),
      0 0 25px rgba(60,255,198,0.5),
      inset 0 0 10px rgba(60,255,198,0.4)
    "
        cursor="pointer"
        transition="all 0.3s ease"
        _hover={{
          transform: 'translateX(-50%) scale(1.05)',
          boxShadow: `
        0 0 15px rgba(60,255,198,1),
        0 0 35px rgba(60,255,198,0.7),
        inset 0 0 15px rgba(60,255,198,0.6)
      `,
        }}
        onClick={onClick}
      >
        {message}

        <Box
          position="absolute"
          bottom="-12px"
          left="50%"
          transform="translateX(-50%) rotate(45deg)"
          width="18px"
          height="18px"
          bg="rgba(10, 15, 30, 0.95)"
          borderRight="2px solid #3CFFC6"
          borderBottom="2px solid #3CFFC6"
          boxShadow="0 0 10px rgba(60,255,198,0.8)"
        />
      </Box>
    );

    // door toast
    const [allowOverviewRender, setAllowOverviewRender] = useState(false);
    const lastVisitedSeqRef = useRef<number | null>(null);
    const prevIndexRef = useRef<number | null>(null);
    const getSeqNumber = (seq: string) => Number(seq.split('.')[1]);

    // door toast
    const handleOverviewToastClick = () => {
      setAllowOverviewRender(true);
    };

    // door toast
    useEffect(() => {
      if (!data?.blockPrimarySequence) return;

      const seq = getSeqNumber(data.blockPrimarySequence);
      prevIndexRef.current = seq;
    }, [data?.blockPrimarySequence]);

    // door toast
    useEffect(() => {
      if (!data?.blockPrimarySequence) return;

      const currentSeq = getSeqNumber(data.blockPrimarySequence);
      const lastSeq = lastVisitedSeqRef.current;

      if (type === 'Overview') {
        // First ever visit
        if (lastSeq === null) {
          setAllowOverviewRender(false);
        }
        // ▶️ Forward navigation
        else if (currentSeq > lastSeq) {
          setAllowOverviewRender(false);
        }
        // ◀️ Backward navigation
        else {
          setAllowOverviewRender(true);
        }
      }

      // 🔥 update history AFTER comparison
      lastVisitedSeqRef.current = currentSeq;
    }, [type, data?.blockPrimarySequence]);

    const [isWeHaveChooseCompleted, setIsWeHaveChooseCompleted] =
      useState(false);
    const memoizedFrame = useMemo(() => {
      const Link = contentByLanguage || data?.blockText;

      const IframeContainer = ({ children }: { children: React.ReactNode }) => (
        <Box
          className="url_box"
          w="100%"
          h={['60vh']}
          maxW="124vw"
          maxH="70vh"
          borderRadius="12px"
          overflow="hidden"
          mx="auto"
        >
          {children}
        </Box>
      );

      // 👉 If link exists → show iframe
      if (Link) {
        // YouTube
        if (Link.includes('youtube.com') || Link.includes('youtu.be')) {
          const videoId = Link.includes('youtu.be')
            ? Link.split('youtu.be/')[1]
            : new URL(Link).searchParams.get('v');

          return (
            <IframeContainer>
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                width="100%"
                height="100%"
                title="YouTube video"
                style={{ border: 'none' }}
                allowFullScreen
              />
            </IframeContainer>
          );
        }

        // Vimeo
        if (Link.includes('vimeo.com')) {
          const videoId = Link.split('/').pop();

          return (
            <IframeContainer>
              <iframe
                src={`https://player.vimeo.com/video/${videoId}`}
                width="100%"
                height="100%"
                title="Vimeo video"
                style={{ border: 'none' }}
                allowFullScreen
              />
            </IframeContainer>
          );
        }

        // Other URLs
        if (Link.startsWith('http')) {
          return (
            <IframeContainer>
              <iframe
                src={Link}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </IframeContainer>
          );
        }
      }

      // 👉 If NO link → show minigame inside same container
      return (
        <IframeContainer>
          <WeHaveChooseMinigame
            gameProgressData={gameProgressData}
            setGameProgressData={setGameProgressData}
            seconds={seconds}
            setProfile={setProfile}
            profile={profile}
            questState={questState}
            setLearnerPlayingDetails={setLearnerPlayingDetails}
            gameInfo={gameInfo}
            Activitydata={Activitydata}
            setActivitydata={setActivitydata}
            formData={formData}
            learnerPlayList={learnerPlayList}
            data={data}
            onCompleted={() => setIsWeHaveChooseCompleted(true)} // ✅ NEW
          />
        </IframeContainer>
      );
    }, [
      data?.blockText,
      contentByLanguage,
      profile,
      questState,
      gameInfo,
      Activitydata,
      formData,
      learnerPlayList,
    ]);
   
    //   const Link = contentByLanguage || data?.blockText;

    //   const IframeContainer = ({ children }: { children: React.ReactNode }) => (
    //     <Box
    //       className="url_box"
    //       w="100%"
    //       h={['60vh']}
    //       maxW="124vw"
    //       maxH="70vh"
    //       borderRadius="12px"
    //       overflow="hidden"
    //       mx="auto"
    //     >
    //       {children}
    //     </Box>
    //   );

    //   // 👉 If link exists → show iframe
    //   if (Link) {
    //     // YouTube
    //     if (Link.includes('youtube.com') || Link.includes('youtu.be')) {
    //       const videoId = Link.includes('youtu.be')
    //         ? Link.split('youtu.be/')[1]
    //         : new URL(Link).searchParams.get('v');

    //       return (
    //         <IframeContainer>
    //           <iframe
    //             src={`https://www.youtube.com/embed/${videoId}`}
    //             width="100%"
    //             height="100%"
    //             title="YouTube video"
    //             style={{ border: 'none' }}
    //             allowFullScreen
    //           />
    //         </IframeContainer>
    //       );
    //     }

    //     // Vimeo
    //     if (Link.includes('vimeo.com')) {
    //       const videoId = Link.split('/').pop();

    //       return (
    //         <IframeContainer>
    //           <iframe
    //             src={`https://player.vimeo.com/video/${videoId}`}
    //             width="100%"
    //             height="100%"
    //             title="Vimeo video"
    //             style={{ border: 'none' }}
    //             allowFullScreen
    //           />
    //         </IframeContainer>
    //       );
    //     }

    //     // Other URLs
    //     if (Link.startsWith('http')) {
    //       return (
    //         <IframeContainer>
    //           <iframe
    //             src={Link}
    //             width="100%"
    //             height="100%"
    //             style={{ border: 'none' }}
    //             sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    //           />
    //         </IframeContainer>
    //       );
    //     }
    //   }

    //   // 👉 If NO link → show minigame inside same container
    //   return (
    //     <IframeContainer>
    //       <SwipeMiniGame
    //         setProfile={setProfile}
    //         profile={profile}
    //         questState={questState}
    //         setLearnerPlayingDetails={setLearnerPlayingDetails}
    //         gameInfo={gameInfo}
    //         Activitydata={Activitydata}
    //         setActivitydata={setActivitydata}
    //         formData={formData}
    //         learnerPlayList={learnerPlayList}
    //         data={data}
    //         onCompleted={() => setIsWeHaveChooseCompleted(true)} // ✅ NEW
    //       />
    //     </IframeContainer>
    //   );
    // }, [
    //   data?.blockText,
    //   contentByLanguage,
    //   profile,
    //   questState,
    //   gameInfo,
    //   Activitydata,
    //   formData,
    //   learnerPlayList,
    // ]);
    const memoizedDragForNow = useMemo(() => {
      const Link = contentByLanguage || data?.blockText;

      const IframeContainer = ({ children }: { children: React.ReactNode }) => (
        <Box
          className="url_box"
          w="100%"
          h={['60vh']}
          maxW="124vw"
          maxH="70vh"
          borderRadius="12px"
          overflow="hidden"
          mx="auto"
        >
          {children}
        </Box>
      );

      // 👉 If link exists → show iframe

      if (Link) {
        // YouTube
        if (Link.includes('youtube.com') || Link.includes('youtu.be')) {
          const videoId = Link.includes('youtu.be')
            ? Link.split('youtu.be/')[1]
            : new URL(Link).searchParams.get('v');

          return (
            <IframeContainer>
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                width="100%"
                height="100%"
                title="YouTube video"
                style={{ border: 'none' }}
                allowFullScreen
              />
            </IframeContainer>
          );
        }

        // Vimeo
        if (Link.includes('vimeo.com')) {
          const videoId = Link.split('/').pop();

          return (
            <IframeContainer>
              <iframe
                src={`https://player.vimeo.com/video/${videoId}`}
                width="100%"
                height="100%"
                title="Vimeo video"
                style={{ border: 'none' }}
                allowFullScreen
              />
            </IframeContainer>
          );
        }

        // Other URLs
        if (Link.startsWith('http')) {
          return (
            <IframeContainer>
              <iframe
                src={Link}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </IframeContainer>
          );
        }
      }

      // 👉 If NO link → show minigame inside same container
      return (
        <IframeContainer>
          <MatchRankPreview
            gameProgressData={gameProgressData}
            setGameProgressData={setGameProgressData}
            setProfile={setProfile}
            profile={profile}
            questState={questState}
            setLearnerPlayingDetails={setLearnerPlayingDetails}
            gameInfo={gameInfo}
            Activitydata={Activitydata}
            setActivitydata={setActivitydata}
            formData={formData}
            learnerPlayList={learnerPlayList}
            data={data}
            onCompleted={() => setIsWeHaveChooseCompleted(true)} // ✅ NEW
          />
        </IframeContainer>
      );
    }, [
      data?.blockText,
      contentByLanguage,
      profile,
      questState,
      gameInfo,
      Activitydata,
      formData,
      learnerPlayList,
    ]);

    const memoizedIframe = useMemo(() => {
      const Link = contentByLanguage || data?.blockText;
      if (!Link) return null;

      const IframeContainer = ({ children }: { children: React.ReactNode }) => (
        <Box
          className="url_box"
          // w="calc(160vh - 28vh)"
          w="100%"
          h={['60vh']}
          // maxW="90vw"
          maxW="124vw"
          maxH="70vh"
          borderRadius="12px"
          overflow="hidden"
          mx="auto"
        >
          {children}
        </Box>
      );

      if (Link.includes('youtube.com') || Link.includes('youtu.be')) {
        const videoId = Link.includes('youtu.be')
          ? Link.split('youtu.be/')[1]
          : new URL(Link).searchParams.get('v');
        return (
          <IframeContainer>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              width="100%"
              height="100%"
              title="YouTube video"
              style={{ border: 'none' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </IframeContainer>
        );
      }

      if (Link.includes('vimeo.com')) {
        const videoId = Link.split('/').pop();
        return (
          <IframeContainer>
            <iframe
              src={`https://player.vimeo.com/video/${videoId}`}
              width="100%"
              height="100%"
              title="Vimeo video"
              style={{ border: 'none' }}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </IframeContainer>
        );
      }

      if (Link.startsWith('http')) {
        return (
          <IframeContainer>
            <iframe
              className="iframe_url"
              src={Link}
              width="100%"
              height="100%"
              title="Website preview"
              style={{
                border: 'none',
                transform: 'scale(1)',
                transformOrigin: 'top left',
              }}
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </IframeContainer>
        );
      }

      return <Text textAlign="center">{Link}</Text>;
    }, [data?.blockText, contentByLanguage]);

    const memoizedOverviewIframe = useMemo(() => {
      const Link = contentByLanguage || data?.blockText;
      if (!Link) return null;

      const IframeContainer = ({ children }: { children: React.ReactNode }) => (
        <Box
          className="url_box"
          w="100%"
          h={['60vh']}
          maxW="124vw"
          maxH="70vh"
          borderRadius="12px"
          overflow="hidden"
          mx="auto"
          position="relative"
          zIndex={25}
          pointerEvents="auto"
        >
          {children}
        </Box>
      );

      // YouTube
      if (Link.includes('youtube.com') || Link.includes('youtu.be')) {
        const videoId = Link.includes('youtu.be')
          ? Link.split('youtu.be/')[1]
          : new URL(Link).searchParams.get('v');

        return (
          <IframeContainer>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              width="100%"
              height="100%"
              title="YouTube video"
              style={{ border: 'none' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </IframeContainer>
        );
      }

      // Vimeo
      if (Link.includes('vimeo.com')) {
        const videoId = Link.split('/').pop();

        return (
          <IframeContainer>
            <iframe
              src={`https://player.vimeo.com/video/${videoId}`}
              width="100%"
              height="100%"
              title="Vimeo video"
              style={{ border: 'none' }}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </IframeContainer>
        );
      }

      // Normal URL
      if (Link.startsWith('http')) {
        return (
          <IframeContainer>
            <iframe
              className="iframe_url"
              src={Link}
              width="100%"
              height="100%"
              title="Website preview"
              style={{
                border: 'none',
                transform: 'scale(1)',
                transformOrigin: 'top left',
              }}
              // sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              sandbox="allow-same-origin allow-scripts  allow-popups allow-forms  allow-modals allow-downloads allow-pointer-lock allow-top-navigation allow-top-navigation-by-user-activation"
            />
          </IframeContainer>
        );
      }

      // Text fallback
      return <Text textAlign="center">{Link}</Text>;
    }, [data?.blockText, contentByLanguage]);

    return (
      <>
        <Box className="storyPart" backgroundPosition={basedOnNDI}>
          {isDoorEntry && gameInfo?.gameData?.gameTheme !== 'false' && (
            <Box
              style={{
                zIndex: 9999999,
                position: 'fixed',
                top: 0, left: 0,
                width: '100%', height: '100%',
                pointerEvents: 'auto',
              }}
            >
              <StoryLoading
                trigger={isDoorEntry}
                questLabel={quest.label}
                questTitle={quest.title}
                onComplete={() => {
                  setIsDoorEntry?.(false);
                }}
              />
            </Box>
          )}
        
          {isLoading && !isDoorEntry  && !doorEntryHasStarted.current &&  (
            <Box
              style={{
                zIndex: 999999,
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            >
              {gameInfo?.gameData?.gameTheme === 'false' ? (
                <InitialLoader />
              ) : (
                <LoadingScreen progress={loadingProgress}  isStoryScreen={currentScreenId === 2} />

              )}
            </Box>
          )}
{!showScenarioTransition && (
<>
          {!isLoading && (
            <>
              {data && type === 'Note' && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Box className="chapter_potrait">
                      <Grid
                        templateColumns="repeat(1, 1fr)"
                        gap={4}
                        position="absolute"
                        top="52%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        className="story_note_grid"
                      >
                        <GridItem colSpan={1} position={'relative'}>
                          <motion.div
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{
                              opacity: animateNote ? 0 : 1,
                              scale: animateNote ? 0 : 1,
                            }}
                            transition={{ duration: 0.5 }}
                          >
                            <Box display={'flex'} justifyContent={'center'}>
                              <Img
                                src={preloadedAssets.note}
                                className="story_note_image"
                                loading="lazy"
                              />

                              <Box className={'note_align'}>
                                <Text
                                  textAlign={'center'}
                                  className="note_title"
                                >
                                  Note
                                </Text>
                              </Box>

                              <Box className={'story_note_content'}>
                                <Box
                                  w={'100%'}
                                  display={'flex'}
                                  justifyContent={'center'}
                                >
                                  <Box className={'story_note_block'}>
                                    <Scrollbar>
                                      <Box
                                        textAlign="center"
                                        letterSpacing="normal"
                                      >
                                        {(() => {
                                          const noteText =
                                            contentByLanguage !== null
                                              ? contentByLanguage
                                              : data?.blockText || '';

                                          const [heading, ...rest] =
                                            noteText.split('<h1>');
                                          const normalText = rest.join('<h1>');

                                          return (
                                            <Box>
                                              {heading && (
                                                <Text mb={2}>{heading}</Text>
                                              )}

                                              {normalText && (
                                                <Text
                                                  fontSize="md"
                                                  whiteSpace="pre-line"
                                                  dangerouslySetInnerHTML={{
                                                    __html: normalText,
                                                  }}
                                                />
                                              )}
                                            </Box>
                                          );
                                        })()}
                                      </Box>
                                    </Scrollbar>
                                  </Box>
                                </Box>

                                <Box className="story_block_btns_box">
                                  <Box
                                    className="story_block_btns"
                                    justifyContent={
                                      !sequenceMatches
                                        ? 'space-between'
                                        : 'center'
                                    }
                                  >
                                    {!sequenceMatches && (
                                      <Img
                                        src={preloadedAssets.left}
                                        className={'interaction_button'}
                                        onClick={() => LastModiPrevData(data)}
                                      />
                                    )}

                                    <Img
                                      src={preloadedAssets.right}
                                      className={'interaction_button'}
                                      onClick={() => getNoteNextData()}
                                      height={sequenceMatches ? '9vh' : '7vh'}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </motion.div>
                        </GridItem>
                      </Grid>
                    </Box>
                  ) : (
                   
                    <div className="h-full flex-grow flex flex-col justify-center items-center pt-24">
                      <div className="overflow-hidden relative rounded-[2.375rem] w-full max-w-[54.875rem]">
                        <div
                          className="flex flex-col gap-5 max-h-fit max-w-[54.875rem] overflow-y-auto overflow-x-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-10 py-8 backdrop-filter backdrop-blur-2xl"
                          style={{
                            animation: "diagonal-wipe 1000ms cubic-bezier(0.33, 1, 0.68, 1) both",
                            background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                            boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                          }}
                        >
                          {/* Title */}
                          <div className="relative">
                            <h1
                              className="text-4xl font-normal tracking-[0.005rem] text-center"
                              style={{
                                color: primaryColor,
                                textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                              }}
                            >
                              {data?.blockHeading ?? "Note"}
                            </h1>
                          </div>

                          {/* Line */}
                          <div className="flex items-center justify-center relative w-full">
                            <div className="w-full">
                              <div className="h-[1px] relative w-full">
                                <div
                                  className="absolute inset-0"
                                  style={{
                                    background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                    opacity: 0.995,
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Content */}
                          <div className="flex-1 w-full flex items-center justify-center px-5 py-4 relative z-0">
                            <div className="w-full max-w-4xl mx-auto">
                              <div className="relative z-10 w-full">
                                {/* <div className="flex flex-col font-rubik font-normal text-[1.188rem] text-white text-justify tracking-tight leading-[2rem] max-h-[300px] overflow-y-auto pr-2 "> */}
                                <div className="flex flex-col font-rubik font-normal text-[1.188rem] text-white text-justify tracking-tight leading-[2rem] max-h-[400px] overflow-y-auto pr-2 ">
                                  <div className="w-full mb-3 cursor-pointer">
                                    {(() => {
                                      const noteText =
                                        contentByLanguage !== null
                                          ? contentByLanguage
                                          : data?.blockText || "";

                                      const [heading, ...rest] =
                                        noteText.split("<h1>");
                                      const normalText = rest.join("<h1>");

                                      return (
                                        <>
                                          {heading && (
                                            <p className="mb-3 text-center">{heading}</p>
                                          )}

                                          {normalText && (
                                            <p
                                              className="whitespace-pre-line"
                                              dangerouslySetInnerHTML={{
                                                __html: normalText,
                                              }}
                                            />
                                          )}
                                        </>
                                      );
                                    })()}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Navigation */}
                          <div className="flex items-center w-full sticky bottom-0 z-10">
                            {!sequenceMatches && (
                              <NavigationArrow
                                direction="left"
                                onClick={() => LastModiPrevData(data)}
                                primaryColor={primaryColor}
                              />
                            )}

                            <div className="ml-auto">
                              <NavigationArrow
                                direction="right"
                                onClick={() => getNoteNextData()}
                                primaryColor={primaryColor}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Glows */}
                        <div className="absolute h-[25rem] w-[30.75rem] -top-[5rem] -right-[5rem] mix-blend-exclusion opacity-20 pointer-events-none">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{ background: primaryColor, transform: "scale(0.8)" }}
                          />
                        </div>

                        <div className="absolute h-[25rem] w-[30.75rem] -top-[7.5rem] left mix-blend-exclusion opacity-15 pointer-events-none">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{ background: primaryColor, transform: "scale(0.8)" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {data && type === 'KeyInsights' && (
                <>
                  <div className="flex h-full flex-grow flex-col items-center justify-center pt-24">
                    <div className="relative w-full max-w-[54.875rem] overflow-hidden rounded-[2.375rem]">
                      <div
                        className="flipYCustom relative flex h-full w-full max-w-[54.875rem] flex-col items-center justify-start gap-5 overflow-x-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                        style={{
                          background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                          boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                        }}
                          onAnimationStart={playFlipSound}
                        onAnimationEnd={stopFlipSound}
                        
                      >
                        {/* Title */}
                        <div className="relative">
                          <h1
                            className="text-center text-4xl font-normal tracking-[0.005rem]"
                            style={{
                              color: primaryColor,
                              textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                            }}
                          >
                            Key Insights
                          </h1>
                        </div>

                        {/* Line */}
                        <div className="relative flex w-full items-center justify-center">
                          <div className="w-full">
                            <div className="relative h-[1px] w-full">
                              <div
                                className="absolute inset-0"
                                style={{
                                  background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                  opacity: 0.995,
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                          <div className="mx-auto w-full max-w-4xl">
                            <div className="relative z-10 w-full">
                              <div className="font-rubik flex max-h-[420px] flex-col overflow-y-auto pr-2 text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white ">
                                {(() => {
                                  const insightText =
                                    contentByLanguage !== null
                                      ? contentByLanguage
                                      : data?.blockText || '';

                                  // Split content by images, videos and URLs while preserving them
                                  const parts = insightText.split(
                                    /(<img[^>]*>|<video[^>]*>.*?<\/video>|https?:\/\/[^\s]+)/gi,
                                  );

                                  return (
                                    <div className="flex flex-col gap-3">
                                      {parts
                                        .map((part: string, index: number) => {
                                          // Check if part is an image tag
                                          const imgMatch = part.match(
                                            /<img[^>]*src=["']([^"']+)["'][^>]*>/i,
                                          );
                                          // Check if part is a video tag
                                          const videoMatch = part.match(
                                            /<video[^>]*src=["']([^"']+)["'][^>]*>/i,
                                          );
                                          // Check if part is a plain URL
                                          const urlMatch =
                                            part.match(/^https?:\/\/[^\s]+$/i);

                                          if (imgMatch) {
                                            const imageUrl = imgMatch[1];
                                            return (
                                              <div
                                                key={index}
                                                className="mb-4 flex justify-center"
                                              >
                                                <img
                                                  src={imageUrl}
                                                  alt="Content image"
                                                  className="w-full max-w-4xl rounded-lg object-cover"
                                                  style={{
                                                    width: '100%',
                                                    maxWidth: '56rem',
                                                    height: '300px',
                                                    border: `1px solid ${primaryColor}`,
                                                    boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                  }}
                                                  onError={(e) => {
                                                    e.currentTarget.style.display =
                                                      'none';
                                                  }}
                                                />
                                              </div>
                                            );
                                          } else if (videoMatch) {
                                            const videoUrl = videoMatch[1];
                                            return (
                                              <div
                                                key={index}
                                                className="mb-4 flex justify-center"
                                              >
                                                <video
                                                  src={videoUrl}
                                                  controls
                                                  className="max-h-[300px] max-w-4xl rounded-lg"
                                                  style={{
                                                    border: `1px solid ${primaryColor}`,
                                                    boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                  }}
                                                  onError={(e) => {
                                                    e.currentTarget.style.display =
                                                      'none';
                                                  }}
                                                >
                                                  Your browser does not support
                                                  the video tag.
                                                </video>
                                              </div>
                                            );
                                          } else if (urlMatch) {
                                            // Check if URL contains image-related keywords or is from known image hosts
                                            const isImageUrl =
                                              /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(
                                                part,
                                              ) ||
                                              /\/(photo|image|img|picture)/i.test(
                                                part,
                                              ) ||
                                              /istockphoto|unsplash|pexels|pixabay|shutterstock/i.test(
                                                part,
                                              );

                                            // Check if URL contains video-related keywords or is from known video hosts
                                            const isVideoUrl =
                                              /\.(mp4|webm|ogg|mov|avi)(\?|$)/i.test(
                                                part,
                                              ) ||
                                              /\/(video|watch|embed)/i.test(
                                                part,
                                              ) ||
                                              /youtube|youtu\.be|vimeo|dailymotion/i.test(
                                                part,
                                              );

                                            if (isImageUrl) {
                                              return (
                                                <div
                                                  key={index}
                                                  className="mb-4 flex justify-center"
                                                >
                                                  <img
                                                    src={part}
                                                    alt="Content image"
                                                    className="w-full max-w-4xl rounded-lg object-cover"
                                                    style={{
                                                      width: '100%',
                                                      maxWidth: '56rem',
                                                      height: '300px',
                                                      border: `1px solid ${primaryColor}`,
                                                      boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                    }}
                                                    onError={(e) => {
                                                      e.currentTarget.style.display =
                                                        'none';
                                                    }}
                                                  />
                                                </div>
                                              );
                                            } else if (isVideoUrl) {
                                              // Handle YouTube URLs
                                              if (
                                                /youtube|youtu\.be/i.test(part)
                                              ) {
                                                const videoId = part.match(
                                                  /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
                                                );
                                                if (videoId) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="mb-4 flex justify-center"
                                                    >
                                                      <iframe
                                                        src={`https://www.youtube.com/embed/${videoId[1]}`}
                                                        className="h-[300px] w-full max-w-4xl rounded-lg"
                                                        style={{
                                                          border: `1px solid ${primaryColor}`,
                                                          boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                        }}
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                      />
                                                    </div>
                                                  );
                                                }
                                              }
                                              // Handle direct video files
                                              return (
                                                <div
                                                  key={index}
                                                  className="mb-4 flex justify-center"
                                                >
                                                  <video
                                                    src={part}
                                                    controls
                                                    className="max-h-[300px] max-w-4xl rounded-lg"
                                                    style={{
                                                      border: `1px solid ${primaryColor}`,
                                                      boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                    }}
                                                    onError={(e) => {
                                                      e.currentTarget.style.display =
                                                        'none';
                                                    }}
                                                  >
                                                    Your browser does not
                                                    support the video tag.
                                                  </video>
                                                </div>
                                              );
                                            } else {
                                              // Show website as embedded iframe preview with immediate fallback
                                              return (
                                                <div
                                                  key={index}
                                                  className="mb-4 flex justify-center"
                                                >
                                                  <div
                                                    className="w-full max-w-4xl rounded-lg"
                                                    style={{
                                                      border: `1px solid ${primaryColor}`,
                                                      boxShadow: `0px 0px 10px rgba(${primaryColorRgb}, 0.3)`,
                                                    }}
                                                  >
                                                    <iframe
                                                      src={part}
                                                      className="h-[300px] w-full rounded-lg"
                                                      frameBorder="0"
                                                      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                                                      style={{
                                                        display: 'block',
                                                      }}
                                                      onLoad={(e) => {
                                                        // Successfully loaded, hide fallback
                                                        const fallback = e
                                                          .currentTarget
                                                          .nextElementSibling as HTMLElement;
                                                        if (fallback)
                                                          fallback.style.display =
                                                            'none';
                                                      }}
                                                    />
                                                    <div
                                                      className="rounded-lg border p-4 text-center"
                                                      style={{
                                                        display: 'block',
                                                        background:
                                                          'rgba(31, 41, 55, 0.8)',
                                                        borderColor:
                                                          'rgba(75, 85, 99, 0.5)',
                                                      }}
                                                    >
                                                      <p className="mb-2 text-gray-300">
                                                        🔗 Website Preview
                                                      </p>
                                                      <p className="mb-3 text-sm text-gray-400">
                                                        This website cannot be
                                                        embedded due to security
                                                        policies
                                                      </p>
                                                      <a
                                                        href={part}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors duration-200 hover:bg-blue-700"
                                                      >
                                                        Open Website →
                                                      </a>
                                                      <p className="mt-2 break-all text-xs text-gray-500">
                                                        {part}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          } else if (part.trim()) {
                                            // Process text content while preserving order
                                            const lines =
                                              getKeyInsightsLines(part);
                                            return lines
                                              .map((item, lineIndex) => {
                                                const cleanItem = item
                                                  .replace(
                                                    /^\s*[\u2022•\-]\s*/,
                                                    '',
                                                  )
                                                  .trim();
                                                // Only add bullet if it's actual text content (not empty or just whitespace)
                                                if (cleanItem) {
                                                  return (
                                                    <div
                                                      key={`${index}-${lineIndex}`}
                                                      className="flex gap-3"
                                                    >
                                                      <span>• {cleanItem}</span>
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              })
                                              .filter(Boolean);
                                          }
                                          return null;
                                        })
                                        .filter(Boolean)}
                                    </div>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="absolute bottom-[4.5rem]  z-50"
                          style={{ bottom: '1.8rem', right: '8rem' }}
                        >
                          <Buttons
                            onClick={handleDownloadPDF}
                            variant="ghost"
                            size="sm"
                            className="h-11 w-[7rem] rounded-3xl px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
                            style={{
                              background: `linear-gradient(275.041deg,
        rgba(${hexToRgb(primaryColor)}, 0.7) 7.25%,
        rgba(0, 0, 0, 0.8) 84.803%)`,
                              border: `1px solid ${primaryColor}`,
                              boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                            }}
                          >
                            Download
                          </Buttons>
                        </div>
                        {/* Navigation */}
                        <div className="sticky bottom-0 z-10 flex w-full items-center">
                          {!sequenceMatches && (
                            <NavigationArrow
                              direction="left"
                              onClick={() => LastModiPrevData(data)}
                              primaryColor={primaryColor}
                            />
                          )}

                          <div className="ml-auto">
                            <NavigationArrow
                              direction="right"
                              onClick={() => getNoteNextData()}
                              primaryColor={primaryColor}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Glows */}
                      <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>

                      <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data &&
                type === 'PreAssessment' &&
                (() => {
                  const currentQuest = parseInt(profile?.currentQuest || '1');
                  const isReplay =
                    questState && questState[currentQuest] === 'replayallowed';

                  // Show "one-time only" message if in replay mode OR already completed (on return visit)
                  if (isReplay || preAssessmentShowingMessage) {
                    return (
                      <div className="flex h-full flex-grow flex-col items-center justify-center pt-24">
                        <div className="relative w-full max-w-[54.875rem] overflow-hidden rounded-[2.375rem]">
                          <div
                            className="relative flex h-full max-h-fit w-full max-w-[54.875rem] flex-col items-center justify-start gap-5 overflow-y-auto overflow-x-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                            style={{
                              animation: "fade-in 350ms ease-out both",
                              background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                              boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                            }}
                          >
                            <div className="relative">
                              <h1
                                className="text-center text-4xl font-normal tracking-[0.005rem]"
                                style={{
                                  color: primaryColor,
                                  textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                                }}
                              >
                                Practice
                              </h1>
                            </div>

                            <div className="relative flex w-full items-center justify-center">
                              <div className="w-full">
                                <div className="relative h-[1px] w-full">
                                  <div
                                    className="absolute inset-0"
                                    style={{
                                      background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                      opacity: 0.995,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                           <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                            <div className="mx-auto w-full max-w-4xl">
                              <div className="relative z-10 w-full">
                                {/* <div className="flex flex-col font-rubik font-normal text-[1.188rem] text-white text-justify tracking-tight leading-[2rem] max-h-[300px] overflow-y-auto pr-2 "> */}
                                <div className="font-rubik flex max-h-[400px] flex-col overflow-y-auto pr-2 text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white ">
                                  <div className="mb-3 w-full cursor-pointer">
                                    The initial practice is one-time only. You
                                    can retry the post-scenario practice at the
                                    end of the quest.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                            <div className="sticky bottom-0 z-10 flex w-full items-center">
                              {!sequenceMatches && (
                                <NavigationArrow
                                  direction="left"
                                  onClick={() => LastModiPrevData(data)}
                                  primaryColor={primaryColor}
                                />
                              )}

                              <div className="ml-auto">
                                <NavigationArrow
                                  direction="right"
                                  onClick={() => getNoteNextData()}
                                  primaryColor={primaryColor}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[9.375rem]"
                              style={{
                                background: primaryColor,
                                transform: 'scale(0.8)',
                              }}
                            />
                          </div>

                          <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                            <div
                              className="absolute inset-0 rounded-full blur-[9.375rem]"
                              style={{
                                background: primaryColor,
                                transform: 'scale(0.8)',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div className="mt-5 flex h-full flex-grow flex-col items-center justify-center pt-5">
                      <div
                        className="relative flex w-full flex-col overflow-hidden rounded-[2.375rem]"
                        style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                      >
                        <div
                          data-aos="slide-left"
                          data-aod-duration="520"
                          className="relative flex max-h-[85vh] w-full flex-col rounded-[2.375rem] backdrop-blur-2xl backdrop-filter"
                          style={{
                            background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                            boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                            maxWidth: '85rem',
                          }}
                        >
                          {/* Fixed Title Section */}
                          <div className="w-full px-10 pb-5 pt-8">
                            <div className="relative mb-5">
                              <h1
                                className="text-center text-4xl font-normal tracking-[0.005rem]"
                                style={{
                                  color: primaryColor,
                                  textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                                }}
                              >
                               Practice
                              </h1>
                            </div>

                            <div className="relative flex w-full items-center justify-center">
                              <div className="w-full">
                                <div className="relative h-[1px] w-full">
                                  <div
                                    className="absolute inset-0"
                                    style={{
                                      background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                      opacity: 0.995,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Scrollable Content */}
                          <div className="flex-1 overflow-y-auto px-10">
                            <div className="w-full py-4">
                              <div className="space-y-4">
                                <PreTraining
                                AssignId={AssignId}
                                seconds={seconds}
                                currentQuestNo={profile?.currentQuest}
                                  Activitydata={Activitydata}
                                  setActivitydata={setActivitydata}
                                  formData={formData}
                                  learnerPlayList={learnerPlayList}
                                  data={data}
                                   questState={questState}
                                  // onComplete={() =>
                                  //   setPreAssessmentCompleted(true)

                                  // }
                                    onComplete={() => {
                                    setPreAssessmentCompleted(true);
                                        const questKey = String(currentQuestNo ?? profile?.currentQuest ?? 'default');
                                        sessionStorage.setItem(`preAssessmentCompleted_quest_${questKey}`, 'true');
                                    setLearnerPlayingDetails((prev: any) => ({
                                      ...prev,
                                      preAssessment: {
                                        ...prev.preAssessment,
                                        [profile?.currentQuest]: true,
                                      },
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Fixed Navigation at Bottom */}
                          <div className="relative z-50 flex items-center justify-between w-full px-10 pb-8">
                          <div className="flex w-full items-center justify-between px-10 pb-8">
                            <div>
                              {!sequenceMatches && (
                                <NavigationArrow
                                  direction="left"
                                  onClick={() => LastModiPrevData(data)}
                                  primaryColor={primaryColor}
                                />
                              )}
                            </div>
                            <div>
                              {preAssessmentCompleted ? (
                                <NavigationArrow
                                  direction="right"
                                  onClick={() => getNoteNextData()}
                                  primaryColor={primaryColor}
                                />
                              ) : (
                                <div
                                  style={{ width: '3.75rem', height: '2.5rem' }}
                                />
                              )}
                            </div>
                          </div>
                          </div>
                        </div>

                        {/* Glows */}
                        <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>

                        {/* Glows */}
                        <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>

                        <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })()}
              {data && type === 'PostAssessment' && (
                <div className="mt-5 flex h-full flex-grow flex-col items-center justify-center pt-5">
                  <div
                    className="relative flex w-full flex-col overflow-hidden rounded-[2.375rem]"
                    style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                  >
                    <div
                      data-aos="slide-right"
                      data-aod-duration="520"
                      className="relative flex max-h-[85vh] w-full flex-col rounded-[2.375rem] backdrop-blur-2xl backdrop-filter"
                      style={{
                        background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                        boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                        maxWidth: '85rem',
                      }}
                    >
                      {/* Fixed Title Section */}
                      <div className="w-full px-10 pb-5 pt-8">
                        <div className="relative mb-5">
                          <h1
                            className="text-center text-4xl font-normal tracking-[0.005rem]"
                            style={{
                              color: primaryColor,
                              textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                            }}
                          >
                            Practice
                          </h1>
                        </div>

                        <div className="relative flex w-full items-center justify-center">
                          <div className="w-full">
                            <div className="relative h-[1px] w-full">
                              <div
                                className="absolute inset-0"
                                style={{
                                  background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                  opacity: 0.995,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Scrollable Content */}
                      <div className="flex-1 overflow-y-auto px-10">
                        <div className="w-full py-4">
                          <PostTraining
                          AssignId={AssignId}
                          seconds={seconds}
                           questState={questState}
                            currentQuestNo={profile?.currentQuest}
                            Activitydata={Activitydata}
                            setActivitydata={setActivitydata}
                            key={`${formData?.isReplay}-${learnerPlayList?.isReplay}-${formData?.gameType}-${learnerPlayList?.gameType}`}
                            formData={formData}
                            learnerPlayList={learnerPlayList}
                            data={data}
                            onComplete={() => setPostAssessmentCompleted(true)}
                          />
                        </div>
                      </div>

                      {/* Fixed Navigation at Bottom */}
                      <div className="flex w-full items-center justify-between px-10 pb-8">
                        <div>
                          {!sequenceMatches && (
                            <NavigationArrow
                              direction="left"
                              onClick={() => LastModiPrevData(data)}
                              primaryColor={primaryColor}
                            />
                          )}
                        </div>
                        <div>
                          {postAssessmentCompleted ? (
                            <NavigationArrow
                              direction="right"
                              onClick={() => getNoteNextData()}
                              primaryColor={primaryColor}
                            />
                          ) : (
                            <div
                              style={{ width: '3.75rem', height: '2.5rem' }}
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Glows */}
                    <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                      <div
                        className="absolute inset-0 rounded-full blur-[9.375rem]"
                        style={{
                          background: primaryColor,
                          transform: 'scale(0.8)',
                        }}
                      />
                    </div>

                    <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                      <div
                        className="absolute inset-0 rounded-full blur-[9.375rem]"
                        style={{
                          background: primaryColor,
                          transform: 'scale(0.8)',
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              {data && type === 'WehaveChoose' && (
                <>
                  <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                    <div
                      className="relative w-full  overflow-hidden rounded-[2.375rem]"
                      style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                    >
                      <div
                        className="relative flex max-h-[85vh]  w-full flex-col items-center justify-start gap-5 rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                        style={{
                          background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                          boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                          maxWidth: '85rem',
                        }}
                      >
                        {/* Title */}
                        <div className="relative">
                          <h1
                            className="text-center text-4xl font-normal tracking-[0.005rem]"
                            style={{
                              color: primaryColor,
                              textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                            }}
                          >
                            Mini Game
                          </h1>
                        </div>

                        {/* Line */}
                        <div className="relative flex w-full items-center justify-center">
                          <div className="w-full">
                            <div className="relative h-[1px] w-full">
                              <div
                                className="absolute inset-0"
                                style={{
                                  background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                  opacity: 0.995,
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                          <div
                            className="mx-auto w-full"
                            style={{ maxWidth: '70rem' }}
                          >
                            <div className="relative z-10 w-full">
                              <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white">
                                <div className="mb-3 w-full cursor-pointer">
                                 
                                  <WeHaveChooseMinigame
                                  AssignId={AssignId}
                                    gameProgressData={gameProgressData}
                          setGameProgressData={setGameProgressData}
                                  seconds={seconds}
                                    setProfile={setProfile}
                                     learner_game_play_id={ learner_game_play_id}
                                    profile={profile}
                                    questState={questState}
                                    setLearnerPlayingDetails={
                                      setLearnerPlayingDetails
                                    }
                                      isAudioPaused={isAudioPaused}
                                    gameInfo={gameInfo}
                                    Activitydata={Activitydata}
                                    setActivitydata={setActivitydata}
                                    formData={formData}
                                    learnerPlayList={learnerPlayList}
                                    data={data}
                                       WeHaveChooseCompleted={WeHaveChooseCompleted}
  setWeHaveChooseCompleted={setWeHaveChooseCompleted}
                                    onCompleted={() =>
                                      setWeHaveChooseCompleted(true)
                                    } // ✅ NEW
                                  />
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Navigation */}
                        {/* Navigation - Centered Left & Right */}
                        <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between px-8">
                          {/* Left Arrow */}
                          <div
                            className="pointer-events-auto"
                            style={{ marginLeft: '-1rem' }}
                          >
                            {!sequenceMatches && (
                              <NavigationArrow
                                direction="left"
                                onClick={() => LastModiPrevData(data)}
                                primaryColor={primaryColor}
                              />
                            )}
                          </div>
                        
                              <div className="pointer-events-auto">
                            {['WehaveChoose'].includes(type) &&
                            WeHaveChooseCompleted ? (
                              <NavigationArrow
                                direction="right"
                                onClick={() => {
                                  getNoteNextData();
                                 
                                }}
                                primaryColor={primaryColor}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Glows */}
                      <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>

                      <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {data && type === 'SwipeMiniGame' && (
                <>
                  <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                    <div
                      className="relative w-full  rounded-[2.375rem]"
                      style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                    >
                      <div
                        className="relative flex max-h-[85vh]  w-full flex-col items-center justify-start gap-5  rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                        style={{
                          background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                          boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                          maxWidth: '85rem',
                        }}
                      >
                        {/* Title */}
                        <div className="relative">
                          <h1
                            className="text-center text-4xl font-normal tracking-[0.005rem]"
                            style={{
                              color: primaryColor,
                              textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                            }}
                          >
                            Mini Game
                          </h1>
                        </div>

                        {/* Line */}
                        <div className="relative flex w-full items-center justify-center">
                          <div className="w-full">
                            <div className="relative h-[1px] w-full">
                              <div
                                className="absolute inset-0"
                                style={{
                                  background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                  opacity: 0.995,
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                          <div
                            className="mx-auto w-full"
                            style={{ maxWidth: '70rem' }}
                          >
                            <div className="relative z-10 w-full">
                              <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white">
                                <div className="mb-3 w-full cursor-pointer">
                                
                                  <SwipeMiniGame
                                  AssignId={AssignId}
                                    gameProgressData={gameProgressData}
                          setGameProgressData={setGameProgressData}
                                  seconds={seconds}
                                     isSwipeMiniGameCompleted={isSwipeMiniGameCompleted}
  setIsSwipeMiniGameCompleted={setIsSwipeMiniGameCompleted}
                                   learner_game_play_id={ learner_game_play_id}
                                    setProfile={setProfile}
                                    profile={profile}
                                    questState={questState}
                                    setLearnerPlayingDetails={
                                      setLearnerPlayingDetails
                                    }
                                      isAudioPaused={isAudioPaused}
                                    gameInfo={gameInfo}
                                    Activitydata={Activitydata}
                                    setActivitydata={setActivitydata}
                                    formData={formData}
                                    learnerPlayList={learnerPlayList}
                                    data={data}
                                   
  onCompleted={() => {

  setIsSwipeMiniGameCompleted(true);

}}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Navigation */}
                        {/* Navigation - Centered Left & Right */}
                        <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between px-8">
                          {/* Left Arrow */}
                          <div
                            className="pointer-events-auto"
                            style={{ marginLeft: '-1rem' }}
                          >
                            {!sequenceMatches && (
                              <NavigationArrow
                                direction="left"
                                onClick={() => LastModiPrevData(data)}
                                primaryColor={primaryColor}
                              />
                            )}
                          </div>
                        
                               <div className="pointer-events-auto">
                            {['SwipeMiniGame'].includes(type) &&
                            isSwipeMiniGameCompleted ? (
                              <NavigationArrow
                                direction="right"
                                // onClick={() => {
                                //   getNoteNextData();
                                //   setIsWeHaveChooseCompleted(false); // Reset for next time
                                // }}
                                onClick={() => {
  getNoteNextData();

  setTimeout(() => {
    // setIsWeHaveChooseCompleted(false);
    // setIsSwipeMiniGameCompleted(false);
  }, 200);
}}
                                primaryColor={primaryColor}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Glows */}
                      <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>

                      <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {data && type === 'DragForNow' && (
                <>
                  <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                    <div
                      className="relative w-full  overflow-hidden rounded-[2.375rem]"
                      style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                    >
                      <div
                        className="relative flex max-h-[85vh] w-full flex-col items-center justify-start gap-5 rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                        style={{
                          background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                          boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                          maxWidth: '85rem',
                        }}
                      >
                        {/* Title */}
                        <div className="relative">
                          <h1
                            className="text-center text-4xl font-normal tracking-[0.005rem]"
                            style={{
                              color: primaryColor,
                              textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                            }}
                          >
                            Mini Game
                          </h1>
                        </div>

                        {/* Line */}
                        <div className="relative flex w-full items-center justify-center">
                          <div className="w-full">
                            <div className="relative h-[1px] w-full">
                              <div
                                className="absolute inset-0"
                                style={{
                                  background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                  opacity: 0.995,
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                          <div
                            className="mx-auto w-full"
                            style={{ maxWidth: '70rem' }}
                          >
                            <div className="relative z-10 w-full">
                              <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white">
                                <div className="mb-3 w-full cursor-pointer">
                                

                                  <MatchRankPreview
                                  AssignId={AssignId}
                                    gameProgressData={gameProgressData}
                          setGameProgressData={setGameProgressData}
                                    setProfile={setProfile}
                                    profile={profile}
                                    questState={questState}
                                    setLearnerPlayingDetails={
                                      setLearnerPlayingDetails
                                    }
                                     learner_game_play_id={ learner_game_play_id}
                                      isAudioPaused={isAudioPaused}
                                    gameInfo={gameInfo}
                                    Activitydata={Activitydata}
                                    setActivitydata={setActivitydata}
                                    formData={formData}
                                    learnerPlayList={learnerPlayList}
                                    data={data}
                                    // onCompleted={() =>
                                    //   setIsWeHaveChooseCompleted(true)
                                    // } // ✅ NEW

                                     isDragForNowCompleted={isDragForNowCompleted}
  setIsDragForNowCompleted={setIsDragForNowCompleted}
                                    onCompleted={() => setIsDragForNowCompleted(true)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Navigation */}
                        {/* Navigation - Centered Left & Right */}
                        <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between px-8">
                          {/* Left Arrow */}
                          <div
                            className="pointer-events-auto"
                            style={{ marginLeft: '-1rem' }}
                          >
                            {!sequenceMatches && (
                              <NavigationArrow
                                direction="left"
                                onClick={() => LastModiPrevData(data)}
                                primaryColor={primaryColor}
                              />
                            )}
                          </div>
                          {/* Right Arrow */}
                          {/* <div className="pointer-events-auto"
   style={{marginRight:"-1rem"}}
   >
    <NavigationArrow
      direction="right"
      onClick={() => {
        getNoteNextData();
      }}
      primaryColor={primaryColor}
    />
  </div> */}
                          {/* <div className="pointer-events-auto">
                            {['DragForNow'].includes(type) &&
                            isWeHaveChooseCompleted ? (
                              <NavigationArrow
                                direction="right"
                                onClick={() => {
                                  getNoteNextData();
                                  setIsWeHaveChooseCompleted(false); // Reset for next time
                                }}
                                primaryColor={primaryColor}
                              /> */}

                               <div className="pointer-events-auto">
                            {['DragForNow'].includes(type) &&
                            isDragForNowCompleted ? (
                              <NavigationArrow
                                direction="right"
                                onClick={() => {
                                  getNoteNextData();
                                  // setIsWeHaveChooseCompleted(false); // Reset for next time
                                  // setIsDragForNowCompleted(false);
                                }}
                                primaryColor={primaryColor}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Glows */}
                      <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>

                      <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                        <div
                          className="absolute inset-0 rounded-full blur-[9.375rem]"
                          style={{
                            background: primaryColor,
                            transform: 'scale(0.8)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data && type === 'Link' && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Box className="chapter_potrait">
                      <Grid
                        templateColumns="repeat(1, 1fr)"
                        gap={4}
                        position="absolute"
                        top="52%"
                        left="50%"
                        width="80% !important"
                        transform="translate(-50%, -50%)"
                        className="story_note_grid"
                      >
                        <GridItem colSpan={1} position="relative">
                          <motion.div
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{
                              opacity: animateNote ? 0 : 1,
                              scale: animateNote ? 0 : 1,
                            }}
                            transition={{ duration: 0.5 }}
                          >
                            <Box display="flex" justifyContent="center">
                              <Img
                                src={preloadedAssets.Thankyou}
                                className="story_note_image"
                                loading="lazy"
                              />

                              <Box className="url_align">
                                <Text textAlign="center" className="note_title">
                                  Nugget
                                </Text>
                              </Box>

                              <Box className="story_url_content">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  width={'100%'}
                                >
                                  <Box
                                    className="story_url_block"
                                    width={'100%'}
                                  >
                                    <Box textAlign="center" width={'100%'}>
                                      {memoizedIframe}
                                    </Box>
                                  </Box>
                                </Box>

                                <Box className="story_url_block_btns_box">
                                  <Box
                                    className="story_blockurl_btns"
                                    justifyContent={
                                      !sequenceMatches
                                        ? 'space-between'
                                        : 'center'
                                    }
                                  >
                                    {!sequenceMatches && (
                                      <Img
                                        style={{ marginLeft: '-6% !important' }}
                                        src={preloadedAssets.left}
                                        className="interaction_button_left"
                                        onClick={() => LastModiPrevData(data)}
                                      />
                                    )}
                                    <Img
                                      src={preloadedAssets.right}
                                      className="interaction_button"
                                      onClick={() => {
                                        getNoteNextData();
                                      }}
                                      height={sequenceMatches ? '9vh' : '7vh'}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </motion.div>
                        </GridItem>
                      </Grid>
                    </Box>
                  ) : (
                    <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                      <div
                        className="relative w-full  overflow-hidden rounded-[2.375rem]"
                        style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                      >
                        <div
                          className="relative flex max-h-[85vh]  w-full flex-col items-center justify-start gap-5 overflow-y-auto overflow-x-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                          style={{
                            animation: "iris-open 700ms ease-out both",
                            background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                            boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                            maxWidth: '85rem',
                          }}
                        >
                          {/* Title */}
                          <div className="relative">
                            <h1
                              className="text-center text-4xl font-normal tracking-[0.005rem]"
                              style={{
                                color: primaryColor,
                                textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                              }}
                            >
                              Nugget
                            </h1>
                          </div>

                          {/* Line */}
                          <div className="relative flex w-full items-center justify-center">
                            <div className="w-full">
                              <div className="relative h-[1px] w-full">
                                <div
                                  className="absolute inset-0"
                                  style={{
                                    background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                    opacity: 0.995,
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Content */}
                          <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                            <div
                              className="mx-auto w-full"
                              style={{ maxWidth: '70rem' }}
                            >
                              <div className="relative z-10 w-full">
                                <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white">
                                  <div className="mb-3 w-full cursor-pointer">
                                    {memoizedIframe}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Navigation */}
                          {/* Navigation - Centered Left & Right */}
                          <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between px-8">
                            {/* Left Arrow */}
                            <div
                              className="pointer-events-auto"
                              style={{ marginLeft: '-1rem' }}
                            >
                              {!sequenceMatches && (
                                <NavigationArrow
                                  direction="left"
                                  onClick={() => LastModiPrevData(data)}
                                  primaryColor={primaryColor}
                                />
                              )}
                            </div>
                            {/* Right Arrow */}
                            <div
                              className="pointer-events-auto"
                              style={{ marginRight: '-1rem' }}
                            >
                              <NavigationArrow
                                direction="right"
                                onClick={() => {
                                  getNoteNextData();
                                }}
                                primaryColor={primaryColor}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Glows */}
                        <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>

                        <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {data && type === 'Overview' && (
                <>
                  {!allowOverviewRender ? (
                    Number(profile?.currentQuest) === 1 ? (
                      <HologramGateQuest1
                        questId={1}
                        onUnlock={() => setAllowOverviewRender(true)}
                      />
                    ) : Number(profile?.currentQuest) === 2 ? (
                      <HologramGateQuest2
                        questId={2}
                        onUnlock={() => setAllowOverviewRender(true)}
                      />
                    ) : Number(profile?.currentQuest) === 3 ? (
                      <HologramGateQuest3
                        questId={3}
                        onUnlock={() => setAllowOverviewRender(true)}
                      />
                    ) : Number(profile?.currentQuest) === 4 ? (
                      <HologramGateQuest4
                        questId={4}
                        onUnlock={() => setAllowOverviewRender(true)}
                      />
                    ) : null
                  ) : (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box className="chapter_potrait">
                          <Grid
                            templateColumns="repeat(1, 1fr)"
                            gap={4}
                            position="absolute"
                            top="52%"
                            left="50%"
                            width="80% !important"
                            transform="translate(-50%, -50%)"
                            className="story_note_grid"
                          >
                            <GridItem colSpan={1} position="relative">
                              <motion.div
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{
                                  opacity: animateNote ? 0 : 1,
                                  scale: animateNote ? 0 : 1,
                                }}
                                transition={{ duration: 0.5 }}
                              >
                                <Box display="flex" justifyContent="center">
                                  <Img
                                    src={preloadedAssets.Thankyou}
                                    className="story_note_image"
                                    loading="lazy"
                                  />

                                  <Box className="url_align">
                                    <Text
                                      textAlign="center"
                                      className="note_title"
                                    >
                                      Overview
                                    </Text>
                                  </Box>

                                  <Box className="story_url_content">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      width={'100%'}
                                    >
                                      <Box
                                        className="story_url_block"
                                        width={'100%'}
                                      >
                                        <Box textAlign="center" width={'100%'}>
                                          {memoizedOverviewIframe}
                                        </Box>
                                      </Box>
                                    </Box>

                                    <Box className="story_url_block_btns_box">
                                      <Box
                                        className="story_blockurl_btns"
                                        justifyContent={
                                          !sequenceMatches
                                            ? 'space-between'
                                            : 'center'
                                        }
                                      >
                                        {!sequenceMatches && (
                                          <Img
                                            style={{
                                              marginLeft: '-6% !important',
                                            }}
                                            src={preloadedAssets.left}
                                            className="interaction_button_left"
                                            onClick={() =>
                                              LastModiPrevData(data)
                                            }
                                          />
                                        )}
                                        <Img
                                          src={preloadedAssets.right}
                                          className="interaction_button"
                                          onClick={() => {
                                            getNoteNextData();
                                          }}
                                          height={
                                            sequenceMatches ? '9vh' : '7vh'
                                          }
                                        />
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                              </motion.div>
                            </GridItem>
                          </Grid>
                        </Box>
                      ) : (
                        <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                          <div
                            className="relative w-full  overflow-hidden rounded-[2.375rem]"
                            style={{ maxWidth: '85rem', maxHeight: '65rem' }}
                          >
                            <div
                              className="zoomInCustom relative flex max-h-[85vh]  w-full flex-col items-center justify-start gap-5 overflow-y-auto overflow-x-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                              // onAnimationStart={playZoomSound}
                              // onAnimationEnd={stopZoomSound}
                              style={{
                                background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColorRgb}, 0.2) 107.18%)`,
                                boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                                maxWidth: '85rem',
                              }}
                            >
                              {/* Title */}
                              <div className="relative">
                                <h1
                                  className="text-center text-4xl font-normal tracking-[0.005rem]"
                                  style={{
                                    color: primaryColor,
                                    textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                                  }}
                                >
                                  Overview
                                </h1>
                              </div>

                              {/* Line */}
                              <div className="relative flex w-full items-center justify-center">
                                <div className="w-full">
                                  <div className="relative h-[1px] w-full">
                                    <div
                                      className="absolute inset-0"
                                      style={{
                                        background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                        opacity: 0.995,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Content */}
                              <div className="relative z-0 flex w-full flex-1 items-center justify-center px-5 py-4">
                                <div
                                  className="mx-auto w-full"
                                  style={{ maxWidth: '70rem' }}
                                >
                                  <div className="relative z-10 w-full">
                                    <div className="font-rubik flex flex-col text-justify text-[1.188rem] font-normal leading-[2rem] tracking-tight text-white">
                                      <div className="mb-3 w-full cursor-pointer">
                                        {memoizedOverviewIframe}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Navigation */}
                              {/* Navigation - Centered Left & Right */}
                              <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between px-8">
                                {/* Left Arrow */}
                                {!sequenceMatches && (
                                  <div
                                    className="pointer-events-auto"
                                    style={{ marginLeft: '-1rem' }}
                                  >
                                    <NavigationArrow
                                      direction="left"
                                      onClick={() => LastModiPrevData(data)}
                                      primaryColor={primaryColor}
                                    />
                                  </div>
                                )}

                                {/* Right Arrow */}
                                <div
                                  className="pointer-events-auto"
                                  style={{ marginRight: '-1rem' }}
                                >
                                  <NavigationArrow
                                    direction="right"
                                    onClick={() => {
                                      getNoteNextData();
                                    }}
                                    primaryColor={primaryColor}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Glows */}
                            <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                              <div
                                className="absolute inset-0 rounded-full blur-[9.375rem]"
                                style={{
                                  background: primaryColor,
                                  transform: 'scale(0.8)',
                                }}
                              />
                            </div>

                            <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                              <div
                                className="absolute inset-0 rounded-full blur-[9.375rem]"
                                style={{
                                  background: primaryColor,
                                  transform: 'scale(0.8)',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              {data && type === 'ScenarioCompletion' && (
                <>
                   {showScenarioLeaderboard === true ? (
                    <ScenarioLeaderboard
                    AssignId={AssignId}
                      setData={setData}
                    setOptions={setOptions}
                    Activitydata={Activitydata}
                    seconds={seconds}
                    questState={questState}
                       scenariowisebestscore1={scenariowisebestscore1}
                     sceneriowiseHighestEarnedScore={sceneriowiseHighestEarnedScore}
                      homeLeaderBoard={homeLeaderBoard}
                      setHomeLeaderBoard={setHomeLeaderBoard}
                      setCurrentScreenId={setCurrentScreenId}
                      formData={gameInfo?.gameData}
                      imageSrc={preloadedAssets.Lead}
                      getData={getData}
                      data={data}
                      setType={setType}
                      gameInfo={gameInfo}
                      preloadedAssets={preloadedAssets}
                      setPlayerTodayScore={setPlayerTodayScore}
                      playerTodayScore={playerTodayScore}
                      setCurrentQuestNo={setCurrentQuestNo}
                      setFirstLoading={setFirstLoading}
                      learnerPlayList={learnerPlayList}
                      onLeaderboardBack={onLeaderboardBack}
                      setAnimateNote={setAnimateNote}
                      setShowScenarioLeaderboard={setShowScenarioLeaderboard}
                      onCompletionDone={() => setScenarioCompletionDone(true)}
                      upNext={upNext}
                      profile={profile}
                      // AllLearnerLearderboard={AllLearnerLearderboard}
                      allLearnerScenarioScore={allLearnerScenarioScore}
                      setAllLearnerScenarioScore={setAllLearnerScenarioScore}
                      sceneriowiseEarnedScore={sceneriowiseEarnedScore}
                      setIsPopupNextFlow={setIsPopupNextFlow}
                      // sceneriowiseHighestEarnedScore={sceneriowiseHighestEarnedScore}
                      scenarioTotalScore={scenarioTotalScore}
                      scenarioAllTimeScore={scenarioAllTimeScore}
                      handleScenarioReplayButtonClick={
                        handleScenarioReplayButtonClick
                      }
                    />
                  ) : (
                    scoreLoaded ? (
                    <ScenarioCompletionFutureTheme
                      gameProgressData={gameProgressData}
                          setGameProgressData={setGameProgressData}
                      BlockSeqNextPreviousNotes={BlockSeqNextPreviousNotes}
                       scenariowisebestscore1={scenariowisebestscore1}
                    scoreLoaded={scoreLoaded}
                    setShowScenarioLeaderboard={setShowScenarioLeaderboard}
                      badgename={badgename}
                      // setShowScenarioLeaderboard={setShowScenarioLeaderboard}
                      badgeImage={badgethpath}
                      getData={getData}
                      data={data}
                      sceneriowiseEarnedScore={sceneriowiseEarnedScore}
                      sceneriowiseHighestEarnedScore={sceneriowiseHighestEarnedScore}
                      scenarioTotalScore={scenarioTotalScore}
                      scenarioAllTimeScore={scenarioAllTimeScore}
                      // AllLearnerLearderboard={AllLearnerLearderboard}
                      setAllLearnerScenarioScore={setAllLearnerScenarioScore}
                      allLearnerScenarioScore={allLearnerScenarioScore}
                      LastModiPrevData={LastModiPrevData}
                      getNoteNextData={getNoteNextData}
                      getNoteNextDataone={onScenarioCompletionNext}
                      score={0}
                      pointsEarned={0}
                      stars={0}
                      totalInteractions={0}
                      currentInteraction={0}
                      competencyLevel={0}
                      newCompetencyLevel={0}
                      scenarioType={'basic'}
                      minPassingScore={0}
                      handleScenarioReplayButtonClick={
                        handleScenarioReplayButtonClick
                      }
                      learner_game_play_id={learner_game_play_id}
                      setisScreenshot={setisScreenshot}
                      isScreenshot={isScreenshot}
                      getFeedbackData={getFeedbackData}
                      setFirstLoading={setFirstLoading}
                      gameInfo={gameInfo}
                      profile={profile}
                      FeedbackcurrentPosition={FeedbackcurrentPosition}
                      setFeedbackCurrentPosition={setFeedbackCurrentPosition}
                      backgroundScreenUrl={preloadedAssets?.backgroundImage}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      preloadedAssets={preloadedAssets}
                      getSelectedOptions={getSelectedOptions}
                      currentScreenId={currentScreenId}
                      setCurrentQuestNo={setCurrentQuestNo}
                      setCurrentScreenId={setCurrentScreenId}
                    />
 ):(
                           <div>Loading score...</div>
                         )
                  )}
                </>
              )}

              {data && type === 'Reflection' && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Box className="chapter_potrait">
                      <Grid
                        templateColumns="repeat(1, 1fr)"
                        gap={4}
                        position="absolute"
                        top="52%"
                        left="50%"
                        width="80% !important"
                        transform="translate(-50%, -50%)"
                        className="story_note_grid"
                      >
                        <GridItem colSpan={1} position="relative">
                          <motion.div
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{
                              opacity: animateNote ? 0 : 1,
                              scale: animateNote ? 0 : 1,
                            }}
                            transition={{ duration: 0.5 }}
                          >
                            <Box display="flex" justifyContent="center">
                              <Img
                                src={preloadedAssets.Thankyou}
                                className="story_note_image"
                                loading="lazy"
                              />

                              <Box className="url_align">
                                <Text textAlign="center" className="note_title">
                                  Reflection
                                </Text>
                              </Box>

                              <Box className="story_url_content">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  width={'100%'}
                                >
                                  <Box
                                    className="story_url_block"
                                    width={'100%'}
                                  >
                                    <Box textAlign="center" width={'100%'}>
                                      {memoizedIframe}
                                    </Box>
                                  </Box>
                                </Box>

                                <Box className="story_url_block_btns_box">
                                  <Box
                                    className="story_blockurl_btns"
                                    justifyContent={
                                      !sequenceMatches
                                        ? 'space-between'
                                        : 'center'
                                    }
                                  >
                                    {!sequenceMatches && (
                                      <Img
                                        style={{ marginLeft: '-6% !important' }}
                                        src={preloadedAssets.left}
                                        className="interaction_button_left"
                                        onClick={() => LastModiPrevData(data)}
                                      />
                                    )}
                                    <Img
                                      src={preloadedAssets.right}
                                      className="interaction_button"
                                      onClick={() => {
                                        getNoteNextData();
                                      }}
                                      height={sequenceMatches ? '9vh' : '7vh'}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </motion.div>
                        </GridItem>
                      </Grid>
                    </Box>
                  ) : (
                    <div className="mt-5  flex h-full flex-grow flex-col items-center justify-center pt-5">
                      <div
                        className="relative w-full  overflow-hidden rounded-[2.375rem]"
                        style={{
                          maxWidth: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <motion.div

                          initial={{ opacity: 0, scale: 1.2 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.6, ease: "easeOut" }}
                          // onAnimationStart={() => {
                          //   if (audioRef.current) {
                          //     audioRef.current.currentTime = 0;
                          //     audioRef.current.play().catch(() => {});
                          //   }
                          // }}
                          className="fixAnimationLayer relative flex max-h-[85vh]  w-full max-w-[54.875rem] flex-col items-center justify-start gap-5 overflow-y-auto overflow-x-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-2xl backdrop-filter"
                          style={{
                            background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${hexToRgb(
                              primaryColor,
                            )}, 0.2) 107.18%)`,
                            boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                          }}
                        >
                          {/* Title */}
                          <div className="relative">
                            <h1
                              className="text-center text-4xl font-normal tracking-[0.005rem]"
                              style={{
                                color: primaryColor,
                                textShadow: `rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.5) 0px 0px 9px`,
                              }}
                            >
                              Reflection
                            </h1>
                          </div>

                          {/* Line */}
                          <div className="relative flex w-full items-center justify-center">
                            <div className="w-full">
                              <div className="relative h-[1px] w-full">
                                <div
                                  className="absolute inset-0"
                                  style={{
                                    background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                                    opacity: 0.995,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                       

                          <div className="flex w-full justify-center">
  <div className="flex max-w-[35rem] items-center gap-2 text-white">


    <div className="font-rubik text-lg sm:text-xl font-normal tracking-[-0.09px]">
      <p className="leading-relaxed break-words text-white text-justify">
        {memoizedIframe}
      </p>
    </div>

  </div>
</div>

                          <div className="flex w-full justify-center">
                            <div className="flex w-full max-w-[35rem] flex-col gap-2 text-center">
                              {/* Textarea Container */}
                              <div
                                className="relative w-full min-w-[28rem] shrink-0 overflow-hidden rounded-3xl"
                                style={{
                                  border: `1.433px solid rgba(${hexToRgb(
                                    primaryColor,
                                  )}, 0.5)`,
                                  background: `linear-gradient(21deg, rgba(10, 10, 10, 0.70) -10.76%, rgba(${hexToRgb(
                                    primaryColor,
                                  )}, 0.1) 127.18%)`,
                                }}
                              >
                                <div className="p-4">
                                  <textarea
                                    className="h-[6rem] w-full resize-none border-none bg-transparent text-white placeholder:text-gray-400 focus:outline-none focus:ring-0"
                                    placeholder="Enter your answer here"
                                    rows={5}
                                    value={answers}
                                    onChange={updateAnswer}
                                    style={{
                                      background: 'transparent',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {showReflectionNote && (
<p className="mt-1 text-s italic text-gray-400">
  Note: Please avoid sharing any confidential details.
</p>
)}
                          {/* Navigation */}
                          <div className="sticky bottom-0 z-10 flex w-full items-center">
                            {!sequenceMatches && (
                              <NavigationArrow
                                direction="left"
                                onClick={() => LastModiPrevData(data)}
                                primaryColor={primaryColor}
                              />
                            )}

                            <div className="ml-auto">
                              {/* <NavigationArrow
                                direction="right"
                                onClick={() => {
                                  nextNavigation();
                                  // getNoteNextData();
                                  
                                }}
                                 primaryColor={primaryColor}
                              /> */}
                              {hasAnswer && (
                                <NavigationArrow
                                  direction="right"
                                  onClick={nextNavigation}
                                  primaryColor={primaryColor}
                                />
                              )}
                            </div>
                          </div>
                        </motion.div>

                        {/* Glows */}
                        <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>

                        <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
                          <div
                            className="absolute inset-0 rounded-full blur-[9.375rem]"
                            style={{
                              background: primaryColor,
                              transform: 'scale(0.8)',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {data && (type === 'Dialog' || type === 'response') && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Box className="chapter_potrait">
                      <Box
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <Img
                          className={
                            'dialogue_image animateDialog dialog-transition'
                          }
                          src={preloadedAssets.dial}
                          bottom={animateDialog ? '-200px' : '0'}
                          //  style={{ transition:'none'  }}
                        />
                        <Box position={'relative'}>
                          <Box
                            position={'fixed'}
                            h={'auto'}
                            w={'30%'}
                            left={'5%'}
                            bottom={animateDialog ? '-200' : '11.5vw'}
                            className={'animateDialog title dialog-title'}
                          >
                            <Img
                              src={preloadedAssets.char}
                              w={'100%'}
                              height={'100%'}
                            />
                            <Box
                              position={'absolute'}
                              top={'31%'}
                              left={'25.5%'}
                              w={'48%'}
                              height={'42%'}
                              display={'flex'}
                              justifyContent={'center'}
                              alignItems={'center'}
                              fontWeight={500}
                              textAlign={'center'}
                              fontFamily={'AtlantisText'}
                              color={'#312821'}
                              textTransform={'capitalize'}
                              className="character_name"
                            >
                              <Text
                                whiteSpace={'nowrap'}
                                overflow={'hidden'}
                                textOverflow={'ellipsis'}
                              >
                                {type === 'Dialog'
                                  ? data.blockRoll === '99999'
                                    ? 'Narrator'
                                    : data.blockRoll === '999999'
                                    ? learnerPlayList?.LearnerProfile?.nickName?.trim()
                                      ? learnerPlayList?.LearnerProfile
                                          ?.nickName
                                      : learnerPlayList?.LearnerProfile?.name
                                    : NonPlayerNameLanguage
                                  : data.blockResponseRoll === '99999'
                                  ? 'Narrator'
                                  : data.blockResponseRoll === '999999'
                                  ? learnerPlayList?.LearnerProfile?.nickName?.trim()
                                    ? learnerPlayList?.LearnerProfile?.nickName
                                    : learnerPlayList?.LearnerProfile?.name
                                  : NonPlayerNameLanguage}
                              </Text>
                            </Box>
                          </Box>
                        </Box>

                        <Box
                          className="dialogue_scroll animateDialog animate-dialog-transition"
                          bottom={animateDialog ? '-200px' : '16px'}
                        >
                          <Scrollbar>
                            <Box
                              className="dialogpapercontent"
                              paddingTop={'10px'}
                            >
                              {type === 'Dialog'
                                ? contentByLanguage !== null
                                  ? contentByLanguage
                                  : data?.blockText
                                : resMsg}
                            </Box>
                          </Scrollbar>
                        </Box>

                        <Box
                          display={'flex'}
                          position={'fixed'}
                          justifyContent={'space-between'}
                          w={'95%'}
                          bottom={animateDialog ? '-200px' : '0'}
                          className={'animateDialog animate-dialog-transition '}
                        >
                          {type === 'Dialog' &&
                          sequenceMatches &&
                          !isBackDisabled ? (
                            <Img />
                          ) : (
                            <Img
                              src={preloadedAssets.left}
                              className="dialog_btn"
                              cursor={'pointer'}
                              onClick={() => {
                                handleBackClick(data);
                              }}
                            />
                          )}
                          <Img
                            className="dialog_btn"
                            src={preloadedAssets.right}
                            onClick={() => Updatecontent()}
                          />
                        </Box>

                        <Box
                          display={'flex'}
                          position={'fixed'}
                          justifyContent={'space-between'}
                          w={'95%'}
                          bottom={animateDialog ? '-200px' : '0'}
                          className={'animateDialog animate-dialog-transition'}
                        >
                          {type === 'response' && sequenceMatches ? (
                            <Img
                              src={preloadedAssets.left}
                              className="dialog_btn"
                              cursor={'pointer'}
                              onClick={() => {
                                handleBackClick(data);
                              }}
                            />
                          ) : (
                            <Img
                              src={preloadedAssets.left}
                              className="dialog_btn"
                              cursor={'pointer'}
                              onClick={() => {
                                handleBackClick(data);
                              }}
                            />
                          )}
                          <Img
                            className="dialog_btn"
                            src={preloadedAssets.right}
                            onClick={() => Updatecontent()}
                          />
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Dialogue
                      content={dialogueText}
                      // characterName={characterName}
                      characterName={
                        type === 'response' ? rescharacterName : characterName
                      }
                      characterAvatar={imageName}
                      onNavigate={(direction) => {
                        if (direction === 'left' && !sequenceMatches) {
                          handleBackClick(data);
                        } else if (direction === 'right') {
                          Updatecontent();
                        }
                      }}
                      isFirstContent={sequenceMatches}
                    />
                  )}
                </>
              )}

              {data && type === 'Interaction' && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Interaction
                      prevSelectOption={prevSelectOption}
                      setPrevselectoptions={setPrevselectoptions}
                      data={data}
                      isInteractionButtonDisabled={isInteractionButtonDisabled}
                      handleInteractionBackClick={handleInteractionBackClick}
                      option={option}
                      options={options}
                      optionClick={optionClick}
                      InteractionFunction={InteractionFunction}
                      navTrack={navTrack}
                      preloadedAssets={preloadedAssets}
                      selectedPlayer={selectedPlayer}
                      LastModiPrevData={LastModiPrevData}
                      RepeatSelectOption={RepeatSelectOption}
                      RepeatPrevOption={RepeatPrevOption}
                      contentByLanguage={contentByLanguage}
                      currentScreenId={2}
                      animateInteraction={animateInteraction}
                      gameInfo={gameInfo}
                      handleValidate={handleValidate}
                      questState={questState}
                      SetAudioOptions={SetAudioOptions}
                    />
                  ) : (
                    <InteractionFutureTheme
                      prevSelectOption={prevSelectOption}
                      setPrevselectoptions={setPrevselectoptions}
                      data={data}
                      isInteractionButtonDisabled={isInteractionButtonDisabled}
                      handleInteractionBackClick={handleInteractionBackClick}
                      option={option}
                      options={options}
                      optionClick={optionClick}
                      InteractionFunction={InteractionFunction}
                      navTrack={navTrack}
                      preloadedAssets={preloadedAssets}
                      selectedPlayer={selectedPlayer}
                      LastModiPrevData={LastModiPrevData}
                      RepeatSelectOption={RepeatSelectOption}
                      RepeatPrevOption={RepeatPrevOption}
                      contentByLanguage={contentByLanguage}
                      currentScreenId={2}
                      animateInteraction={animateInteraction}
                      gameInfo={gameInfo}
                      handleValidate={handleValidate}
                      questState={questState}
                      SetAudioOptions={SetAudioOptions}
                    />
                  )}
                </>
              )}

              {data && type === 'feedback' && (
                <>
                  {gameInfo?.gameData?.gameTheme === 'false' ? (
                    <Box className="chapter_potrait">
                      <Grid
                        templateColumns="repeat(1, 1fr)"
                        gap={4}
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        w={'90%'}
                      >
                        <GridItem colSpan={1} position={'relative'}>
                          <motion.div
                            initial={{ y: 800 }}
                            animate={{ y: animateFeedback ? -800 : 0 }}
                            transition={{ duration: 0.1, ease: 'easeOut' }}
                          >
                            <Box
                              w={'fit-content'}
                              display={'flex'}
                              position={'relative'}
                            >
                              <Img
                                src={preloadedAssets.feedi}
                                className="story_note_image"
                                loading="lazy"
                              />
                              <Box
                                position={'absolute'}
                                top={{ base: '5%', md: '6%' }}
                                className="story_feedback_content"
                              >
                                <Box
                                  display={'flex'}
                                  justifyContent={'center'}
                                  alignItems={'center'}
                                  h={'100%'}
                                >
                                  <Box
                                    w={'90%'}
                                    h={'70%'}
                                    display={'flex'}
                                    justifyContent={'center'}
                                    position={'relative'}
                                  >
                                    <Img
                                      src={preloadedAssets?.feedparch}
                                      w={'auto'}
                                      h={'100%'}
                                    />
                                    <Box
                                      position={'absolute'}
                                      top={{
                                        base: '-7px',
                                        sm: '-7px',
                                        lg: '-15px',
                                      }}
                                      width={'100%'}
                                      h={'100%'}
                                      display={'flex'}
                                      flexDirection={'column'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                    >
                                      <Box w={'70%'}>
                                        <Img
                                          src={preloadedAssets.on}
                                          h={'4vh'}
                                          w={'100%'}
                                        />
                                      </Box>
                                      <Scrollbar width="70%" height="65%">
                                        <Box
                                          w={'100%'}
                                          h={'auto'}
                                          overflow={'hidden'}
                                          className="feedback_content_text"
                                        >
                                          <Box display={'flex'} mt={'10px'}>
                                            <Img
                                              className="storyfbicon"
                                              src={preloadedAssets.FB}
                                              h={'1em'}
                                              w={'1em'}
                                            />
                                            {/* <Text textAlign={'justify'}>{feed}</Text> */}
                                            {getSelectedOptions.interactionfeedback ===
                                            'Each' ? (
                                              <Text textAlign={'justify'}>
                                                <p>
                                                  this feedback from
                                                  interactionfeedback
                                                </p>
                                                {getSelectedOptions.qpFeedback}
                                              </Text>
                                            ) : (
                                              <Text textAlign={'justify'}>
                                                {feed}
                                              </Text>
                                            )}
                                          </Box>
                                        </Box>
                                      </Scrollbar>
                                    </Box>
                                    <Box
                                      w={'120%'}
                                      mt={'20px'}
                                      display={'flex'}
                                      justifyContent={'space-between'}
                                      cursor={'pointer'}
                                      position={'absolute'}
                                      bottom={'-8%'}
                                    >
                                      <Img
                                        src={preloadedAssets.left}
                                        className={'interaction_button'}
                                        onClick={() => {
                                          LastModiPrevData(data);
                                        }}
                                      />
                                      <Img
                                        src={preloadedAssets.right}
                                        className={'interaction_button'}
                                        onClick={() => upNext()}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </motion.div>
                        </GridItem>
                      </Grid>
                    </Box>
                  ) : (
                    <Feedback
                      // content={feed}
                      content={
                        getSelectedOptions.interactionfeedback === 'Each'
                          ? getSelectedOptions.qpFeedback
                          : 'the interaction feedback value is not Each,so show this into the feedbackscreen shot file'
                      }
                      onNavigate={(direction) => {
                        if (direction === 'left') {
                          setAnimateFeedback(true);
                          setTimeout(() => {
                            LastModiPrevData(data);
                          }, 500);
                        } else {
                          upNext();
                        }
                      }}
                    />
                  )}
                </>
              )}
            </>
          )}
          </>
          )}
        </Box>
      </>
    );
  },
);

export default Story;

function InitialLoader() {
  return (
    <>
      <Box
        className="Entire-Loader-story"
        style={{ zIndex: '99999 !important' }}
      >
        <motion.div
          className="Entire-Loader-wrapper-story"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ zIndex: '9999999 !important', opacity: 1 }}
        >
          <Img
            src={LoadImg}
            className="load"
            style={{ zIndex: '99999999 !important', opacity: 1 }}
          />
        </motion.div>
      </Box>
    </>
  );
}

